/**
 * =============================================================================
 * Alo.rs 13102026 -- CLEAN-UP BUILD (no A/B: Alo has no variant mechanism)
 * =============================================================================
 *
 * Base: 06072026/ads.js (live since July 2026). Prebid lib unchanged:
 * 30062026/prebid11.21.0.js. Every change below is meant to be revenue-neutral
 * or better without a test; nothing changes which slots exist, their sizes,
 * their bidders, the refresh cadence or the lazy-load distance.
 *
 *   1. PREBID-FIRST BOOT. Until now every Prebid call (setConfig, the user-id
 *      fetches, addAdUnits, the first auction) sat inside googletag.cmd, so
 *      nothing started before gpt.js had loaded. Measured 13.10.2026 on a
 *      throttled phone: Prebid ready at ~16 s, GPT ready at ~31 s, first
 *      auction at ~31.6 s. The slot loop is now split into two copies of the
 *      same branch logic (generated mechanically, see the CHANGELOG):
 *        - buildPrebidAdUnits(): only the adUnitsATF / adUnitsBTF pushes,
 *          runs at once, no GPT needed;
 *        - the copy inside googletag.cmd: only the GPT slot definitions.
 *      The Prebid configuration and the first-screen auction now run from
 *      pbjs.que as soon as Prebid is ready. The GPT request still waits for
 *      the auction (bidsBackHandler -> initAdserver), and the safety timer
 *      that sends GPT without bids is still armed when GPT is ready
 *      (GPT ready + PREBID_TIMEOUT + 300 ms), exactly as before.
 *
 *   2. LAZY OBSERVER GUARD (no wasted auctions). The template marks InText_1
 *      (and InFeed_1 on category pages) with "lazyAd", but both are in the
 *      first-screen batch. The observer ran a second Prebid auction for them
 *      and refreshed nothing (measured on every article load, 13.10.2026).
 *      Now only slots registered in adUnitsBTF are observed and auctioned.
 *
 *   3. TCF CMP WATCHDOG (permanent insurance after the 03.09.2026 outage on
 *      other Ringier sites). The standalone block of Informer 04092026 /
 *      Blic 04092026-2, embedded verbatim except: logs go through
 *      adsDebugLog (?adsDebug=1), and the outage recovery refresh asks this
 *      wrapper to re-send its first-screen slots instead of refreshing every
 *      slot on the page (window.__aloAdsRecoveryRefresh).
 *
 *   4. TAG TARGETING FIX. The template writes adsKeywords.tags (an array);
 *      the wrapper read adsKeywords.articleTags, so the articleTags key was
 *      never sent. It is now sent from tags (articleTags still wins if the
 *      template ever provides it), as a list of values (one per tag).
 *
 *   5. Page-level targeting through googletag.setConfig({ targeting })
 *      (pubads().setTargeting is deprecated), with a fallback to the old
 *      call on a GPT without setConfig. Same keys, same values.
 *
 *   6. Clean-up: schain "validation" flags dropped (no-op on Prebid 10+, the
 *      chain itself is unchanged); Adhesion 1024 px Prebid size written as
 *      [[728, 90]] instead of the flat [728, 90] (same meaning).
 *
 * NOT changed on purpose: desktop size gaps between GPT and Prebid (whether
 * Alo's Prebid line items carry creatives for the extra sizes cannot be
 * checked without Alo GAM access -- a bid in a size no line item serves would
 * displace a smaller bid that does serve), InText_1 stays first-screen
 * (lazy would need an A/B: shared Ogury mobile ad unit id), refresh cadence.
 * =============================================================================
 *
 * Alo.rs ad wrapper - unminified source rebuilt from the uploaded ads.min.js.
 * Updated for Alo HB CSV: legacy bidder removed, ConnectAd/Ogury added, Sticky/Billboard 20s refresh.
 *
 * Main rule from previous wrapper work: ad serving must not be blocked by optional
 * Prebid/user-id/consent delays. GPT should always get a safe initial refresh.
 */
function startAdWrapperOnce() {
  if (window.prebidAuctionRun) {
    return;
  }

  // Extra guard against a rare timing edge case where DOMContentLoaded fires while
  // this file is still being parsed. The wrapper must not run before globals below
  // are initialized.
  if (!Array.isArray(adUnitsATF) || !Array.isArray(adUnitsBTF)) {
    setTimeout(startAdWrapperOnce, 0);
    return;
  }

  window.prebidAuctionRun = true;
  clearTimeout(window.adsLoadTimer);
  runWrapper();
}

// Start earlier than window.load when possible, but keep window.load as a safe fallback.
if (
  document.readyState === "interactive" ||
  document.readyState === "complete"
) {
  setTimeout(startAdWrapperOnce, 0);
} else {
  document.addEventListener("DOMContentLoaded", startAdWrapperOnce);
  window.addEventListener("load", startAdWrapperOnce);
}

// Last-resort fallback in case DOMContentLoaded listener is missed for any reason.
window.adsLoadTimer = setTimeout(startAdWrapperOnce, 2000);

var googletag = googletag || {};

googletag.cmd = googletag.cmd || [];

var pbjs = pbjs || {};

pbjs.que = pbjs.que || [];

var Adhesion,
  Branding_Left,
  Branding_Right,
  Billboard,
  Billboard_2,
  P1,
  P2,
  P3,
  P4,
  P5,
  P6,
  P7,
  P8,
  P9,
  P10,
  P11,
  P12,
  InFeed_1,
  InFeed_2,
  InFeed_3,
  InFeed_4,
  InFeed_5,
  InText_1,
  InText_2,
  InText_3,
  InText_4,
  InText_5,
  PREBID_TIMEOUT = 1500,
  SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30,
  REFRESH_INTERVAL_SECONDS_BY_ADUNIT = {
    Adhesion: 20,
    Billboard: 20,
  },
  GAM_NOREFRESH_ADVERTISER_IDS = [],
  GAM_NOREFRESH_ORDER_IDS = [],
  GAM_NOREFRESH_ADUNITS = ["Branding_Left", "Branding_Right"],
  DISTANCE_IN_PIXELS_FOR_LAZY_LOADING = "500px",
  VISIBILITY_PERCENT_FOR_REFRESH = 0.6,
  adUnitPath = "/21952471017/Alo.rs/",
  adWindowWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth,
  adUnitsATF = [],
  adUnitsBTF = [];


var ADS_QUERY_PARAMS = (function () {
  try {
    return new URLSearchParams(window.location.search || "");
  } catch (error) {
    return null;
  }
})();

function getFirstQueryParam(names) {
  if (!ADS_QUERY_PARAMS) {
    return null;
  }

  for (var i = 0; i < names.length; i++) {
    if (ADS_QUERY_PARAMS.has(names[i])) {
      return ADS_QUERY_PARAMS.get(names[i]);
    }
  }

  return null;
}

function hasQueryFlag(names) {
  if (!ADS_QUERY_PARAMS) {
    return false;
  }

  for (var i = 0; i < names.length; i++) {
    if (!ADS_QUERY_PARAMS.has(names[i])) {
      continue;
    }

    var value = ADS_QUERY_PARAMS.get(names[i]);

    return value === "" || value === "1" || value === "true" || value === "yes";
  }

  return false;
}

function normalizePxQueryValue(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  value = String(value).trim();

  if (/^\d+$/.test(value)) {
    return value + "px";
  }

  if (/^\d+px$/i.test(value)) {
    return value.toLowerCase();
  }

  return null;
}

function normalizeViewabilityQueryValue(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  var parsed = parseFloat(value);

  if (!isFinite(parsed) || parsed <= 0) {
    return null;
  }

  if (parsed > 1) {
    parsed = parsed / 100;
  }

  if (parsed > 1) {
    return null;
  }

  return parsed;
}

function normalizeSecondsQueryValue(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  var parsed = parseInt(value, 10);

  if (!isFinite(parsed) || parsed < 1) {
    return null;
  }

  return parsed;
}

var ADS_DEBUG = hasQueryFlag(["adsDebug", "adDebug", "wrapperDebug"]);

function adsDebugLog() {
  if (!ADS_DEBUG || !window.console || typeof console.log !== "function") {
    return;
  }

  var args = Array.prototype.slice.call(arguments);
  args.unshift("[Alo ads]");
  console.log.apply(console, args);
}

// =============================================================================
// 13102026: TCF CMP WATCHDOG -- embedded from the standalone
// Informer.rs/04092026/cmp-watchdog.js (= the Blic 04092026-2 block).
// Runs at script execution, before the wrapper boots. Passive while the CMP
// works; see its own header below.
// =============================================================================
// =============================================================================
// STANDALONE TCF CMP WATCHDOG (v 04092026, Ringier Serbia ad ops)
// =============================================================================
//
// Purpose: when the page's CMP (consent management platform) fails to load its
// configuration, it answers every TCF query with cmpStatus "loading" forever,
// never shows a banner and never produces a consent string, while reporting
// gdprApplies = true. Consent-aware ad scripts (Google Publisher Tag, Prebid)
// then never send a single ad request and the site serves no ads at all.
// This happened across several Serbian sites on 03.09.2026.
//
// This file is the self-contained fix. It watches the CMP's own loading
// sequence: if the configuration call (cmp.php) completes but no design file
// follows, the configuration was empty for this visitor and the file answers
// all waiting ad scripts with "GDPR does not apply" (the correct resolution
// for a Serbian, non-EEA audience), rescues consumers whose callbacks are
// held inside the consentmanager registry, and re-triggers Google ad requests
// that were dropped while blocked. A visitor whose CMP IS progressing (design
// file requested, banner shown -- e.g. an EU visitor) is never touched, and a
// device set to a clearly EEA timezone is never answered synthetically. It is
// completely passive while the CMP works, and it stands down automatically
// the moment the CMP's configuration is fixed -- the file can stay on the page
// permanently as insurance.
//
// INTEGRATION: include as early as possible, ideally BEFORE gpt.js:
//   <script src=".../cmp-watchdog.min.js"></script>
// The earlier it runs, the fewer rescue paths are needed; it is safe and
// effective in any position. No configuration required. Debug state:
// window.__cmpWatchdog in the browser console.
//
// v 03092026-2: also answers consumers using the TCF postMessage protocol
// (__tcfapiCall / __tcfapiReturn via the __tcfapiLocator frame) -- on some
// pages GPT itself binds to that path and the function-level fix alone is
// not enough (verified live on sd.rs on 03.09.2026).
//
// v 03092026-3: also patches GPP (window.__gpp, the CMP's GPP registry and
// the __gppLocator postMessage protocol). The same broken CMP leaves GPP stuck
// at signalStatus "not ready", and Google Publisher Tag checks GPP
// independently of TCF -- confirmed live on sd.rs and Blic mobile, 03.09.2026.

// =============================================================================
// TCF CMP WATCHDOG
// =============================================================================
//
// Background: a consentmanager.net CMP is embedded in this site's templates.
// When its remote configuration fails to load, the CMP answers every TCF query
// with cmpStatus "loading" forever: no banner is rendered, no consent string
// is ever produced, and gdprApplies stays true. GPT and Prebid are both
// consent-aware, so in that state neither of them sends a single ad request
// and every slot on the site goes dark. This happened for real on 03.09.2026
// and cost a full ad outage.
//
// What the failure actually looks like (measured 04.09.2026): the CMP core
// script loads and its first configuration call (/delivery/cmp.php) completes
// normally, but the answer carries no configuration -- the account's designs
// are all geo-targeted and none is marked as fallback, so a visitor whose
// country matches no design gets nothing. On a healthy load the design file
// (/delivery/customdata/...) is requested within a few milliseconds of
// cmp.php finishing; on the broken load nothing ever follows cmp.php.
//
// What this watchdog does:
//
//   1. It wraps window.__tcfapi in a transparent pass-through proxy. While
//      the CMP behaves normally, the proxy changes nothing: every call and
//      every event goes straight through, and consent behavior is entirely
//      the CMP's.
//
//   2. It watches the CMP's own network activity (the design-file <script>
//      element in the DOM, and the browser's resource timeline). If cmp.php
//      has completed and no design file has been requested for
//      CMP_NO_DESIGN_CONFIRM_MILLISECONDS afterwards, the
//      CMP is in the broken state described above and the watchdog takes
//      over. This is a positive detection of the failure, not a timeout, so
//      it fires early (about 2 seconds into the page) for a broken visitor and
//      NEVER fires for a visitor whose CMP is merely slow but progressing.
//
//   3. A visitor for whom the CMP IS progressing (design file requested, or
//      the CMP's own status advanced, or a real "cmpuishown" / "tcloaded"
//      event arrived) is left entirely to the real CMP. That includes EU
//      visitors, who must see the banner and whose ads must wait for their
//      choice. The watchdog stands down for good on any such signal.
//
//   4. As a last resort, if the CMP shows no progress at all for
//      CMP_WATCHDOG_MAX_WAIT_MILLISECONDS (its scripts never loaded, the
//      vendor is entirely unreachable), the watchdog also takes over, so a
//      genuine vendor outage still cannot black out the site for the
//      non-EEA audience.
//
//   5. Before taking over it checks the visitor's device timezone. A device
//      set to an unambiguously EEA/CH/UK timezone (Berlin, Vienna, Zurich,
//      Paris, ...) is never answered synthetically: for that visitor the
//      watchdog does nothing, and if the CMP cannot serve them they get no
//      ads rather than ads without consent. Timezones that Serbian devices
//      commonly report (the Windows "Belgrade, Bratislava, Budapest,
//      Ljubljana, Prague" group maps to Europe/Budapest on many machines)
//      are deliberately NOT on that list, so a Serbian visitor is never
//      denied ads by this check. It is a fail-safe, not a geo lookup.
//
//   6. On takeover, every TCF consumer that registered through the proxy
//      (GPT, Prebid) immediately receives a synthetic final answer with
//      gdprApplies = false, and every later TCF call is answered the same
//      way. gdprApplies = false is the correct resolution for this site's
//      overwhelmingly Serbian (non-EEA) audience and is exactly how the
//      working consentmanager instances on this network resolve for them.
//
//   7. It is self-healing in both directions. If the account is fixed, the
//      design file arrives on every load and the watchdog never fires. If the
//      real CMP asserts itself after a takeover (a genuine "cmpuishown" or
//      final event), the proxy returns to pass-through, the synthetic answers
//      stop, and the GPT recovery refresh is never issued.
//
// Known limitation, accepted: a consumer that registered its listener
// directly with the broken CMP BEFORE this wrapper executed cannot be
// notified through the proxy; the consentmanager registry rescue below
// covers that case for this vendor specifically.
//
// Debugging: window.__cmpWatchdog exposes
// { wrapped, takenOver, cmpFinal, cmpHealthy, takeoverReason, timezone, timezoneBlocked }.

// After the CMP's configuration call (cmp.php) has completed, how long to wait
// for the design file request before concluding the configuration was empty.
// On a healthy load the design file follows within ~10 ms; 750 ms is a very
// wide margin.
var CMP_NO_DESIGN_CONFIRM_MILLISECONDS = 750;

// Absolute ceiling: if the CMP has shown no progress of any kind for this
// long after the proxy was installed, take over anyway (vendor unreachable).
// Generous on purpose: an EU visitor on a slow connection may need several
// seconds just for cmp.php (measured 2.6 s from Germany), and taking over
// before that would bypass their banner. Serbian visitors on the broken
// instance are not affected by this value at all -- their takeover comes from
// the empty-configuration signature at ~2 s.
var CMP_WATCHDOG_MAX_WAIT_MILLISECONDS = 8000;

// How often the watchdog re-evaluates the CMP's progress.
var CMP_WATCHDOG_POLL_MILLISECONDS = 250;

// Device timezones that identify an EEA/CH/UK visitor beyond reasonable doubt.
// The synthetic "GDPR does not apply" answer is never given to these. The
// list intentionally omits every zone a Serbian device might report:
// Europe/Belgrade itself, and the Windows group-default zones Europe/Budapest
// (Belgrade/Bratislava/Budapest/Ljubljana/Prague group) and Europe/Warsaw
// (Sarajevo/Skopje/Warsaw/Zagreb group), plus Prague, Bratislava, Ljubljana
// and Zagreb which share those groups.
var CMP_WATCHDOG_EEA_DEVICE_TIMEZONES = [
    'Europe/Berlin', 'Europe/Vienna', 'Europe/Zurich', 'Europe/Amsterdam',
    'Europe/Brussels', 'Europe/Luxembourg', 'Europe/Paris', 'Europe/Madrid',
    'Europe/Rome', 'Europe/Malta', 'Europe/Copenhagen', 'Europe/Stockholm',
    'Europe/Oslo', 'Europe/Helsinki', 'Europe/Athens', 'Europe/Bucharest',
    'Europe/Sofia', 'Europe/Vilnius', 'Europe/Riga', 'Europe/Tallinn',
    'Europe/Dublin', 'Europe/London', 'Europe/Lisbon', 'Atlantic/Reykjavik',
    'Atlantic/Madeira', 'Atlantic/Azores', 'Atlantic/Canary', 'Europe/Nicosia',
    'Asia/Nicosia', 'Europe/Vaduz'
];

// The CMP stub is normally installed by the template before this file runs,
// but load order is not guaranteed. If window.__tcfapi is not there yet, the
// watchdog polls for it this often, for at most this long, then gives up
// (no CMP on the page means nothing blocks ad serving and there is nothing
// to guard).
var CMP_APPEARANCE_POLL_MILLISECONDS = 200;
var CMP_APPEARANCE_MAX_WAIT_MILLISECONDS = 10000;

(function installCmpWatchdog() {

    // Read-only state for debugging from the console / remote sessions.
    var watchdogState = {
        wrapped: false,
        takenOver: false,
        cmpFinal: false,
        cmpHealthy: false,
        takeoverReason: null,
        timezone: null,
        timezoneBlocked: false
    };
    window.__cmpWatchdog = watchdogState;

    // The CMP's own __tcfapi function once the proxy is installed.
    var realTcfApi = null;

    // Every listener registered through the proxy, so the watchdog can answer
    // them itself on takeover. Each entry is { callback, syntheticListenerId }.
    var proxiedListeners = [];

    // Synthetic listener ids start high so they can never collide with ids
    // handed out by the real CMP.
    var nextSyntheticListenerId = 100000;

    // The progress poll timer, and when the proxy was installed (poll clock).
    var progressPollTimer = null;
    var proxyInstalledAtMilliseconds = 0;

    // 13102026 (Alo): logs only with ?adsDebug=1, through the wrapper's logger.
    function logWatchdog(message) {
        try {
            adsDebugLog('[cmp-watchdog] ' + message);
        } catch (ignored) {}
    }

    function nowMilliseconds() {
        return new Date().getTime();
    }

    // True while the watchdog's synthetic answers are in force: it has taken
    // over AND the real CMP has neither finished nor asserted itself since.
    function syntheticAnswersActive() {
        return watchdogState.takenOver && !watchdogState.cmpFinal && !watchdogState.cmpHealthy;
    }

    // -------------------------------------------------------------------------
    // Device timezone fail-safe (see point 5 in the header comment).
    // -------------------------------------------------------------------------
    function readDeviceTimezone() {
        try {
            var intlObject = window.Intl || (typeof Intl !== 'undefined' ? Intl : null);
            if (!intlObject || typeof intlObject.DateTimeFormat !== 'function') {
                return null;
            }
            var resolved = intlObject.DateTimeFormat().resolvedOptions();
            if (resolved && typeof resolved.timeZone === 'string' && resolved.timeZone.length > 0) {
                return resolved.timeZone;
            }
        } catch (timezoneError) {
            return null;
        }
        return null;
    }

    function deviceLooksEea() {
        var timezone = readDeviceTimezone();
        watchdogState.timezone = timezone;
        if (timezone === null) {
            // Unknown timezone (very old browser): cannot tell, do not block.
            return false;
        }
        var zoneIndex;
        for (zoneIndex = 0; zoneIndex < CMP_WATCHDOG_EEA_DEVICE_TIMEZONES.length; zoneIndex++) {
            if (CMP_WATCHDOG_EEA_DEVICE_TIMEZONES[zoneIndex] === timezone) {
                return true;
            }
        }
        return false;
    }

    // -------------------------------------------------------------------------
    // CMP progress detection through the resource timeline and the CMP's own
    // public state (see points 2-4 in the header comment).
    // -------------------------------------------------------------------------

    // Returns { configCallCompletedAt: ms-since-page-start or null,
    //           designFileRequested: bool }.
    //
    // The design file is requested by the CMP core as an async <script>
    // element appended to the document the moment cmp.php has executed
    // (measured: 2 ms later). Its download can take several seconds on a slow
    // connection, and a resource-timeline entry only exists once a download
    // has COMPLETED -- so an in-flight design file is invisible in the
    // timeline. The DOM is therefore checked first: a <script> whose src is a
    // consentmanager /delivery/customdata/ URL means the configuration
    // arrived and a design is being fetched, i.e. the CMP is working for this
    // visitor, whether or not the file has finished downloading yet.
    function inspectCmpNetworkActivity() {
        var result = { configCallCompletedAt: null, designFileRequested: false };
        try {
            var scriptElements = document.getElementsByTagName('script');
            var scriptIndex;
            for (scriptIndex = 0; scriptIndex < scriptElements.length; scriptIndex++) {
                var scriptSource = String(scriptElements[scriptIndex].src || '');
                if (scriptSource.indexOf('consentmanager') !== -1 && scriptSource.indexOf('/delivery/customdata/') !== -1) {
                    result.designFileRequested = true;
                    break;
                }
            }
        } catch (domError) {
            // fall through to the timeline check
        }
        try {
            if (!window.performance || typeof window.performance.getEntriesByType !== 'function') {
                return result;
            }
            var resourceEntries = window.performance.getEntriesByType('resource');
            var entryIndex;
            for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                var resourceName = String(resourceEntries[entryIndex].name);
                if (resourceName.indexOf('consentmanager') === -1) {
                    continue;
                }
                if (resourceName.indexOf('/delivery/cmp.php') !== -1) {
                    // responseEnd is exposed for cross-origin resources even
                    // without Timing-Allow-Origin; a still-in-flight request
                    // does not appear in the timeline at all.
                    var responseEnd = resourceEntries[entryIndex].responseEnd;
                    if (typeof responseEnd === 'number' && responseEnd > 0) {
                        if (result.configCallCompletedAt === null || responseEnd < result.configCallCompletedAt) {
                            result.configCallCompletedAt = responseEnd;
                        }
                    }
                }
                if (resourceName.indexOf('/delivery/customdata/') !== -1 || resourceName.indexOf('/delivery/info/') !== -1) {
                    result.designFileRequested = true;
                }
            }
        } catch (performanceError) {
            return result;
        }
        return result;
    }

    // The consentmanager core exposes window.cmpmngr.status: it stays at 1 in
    // the broken state and advances (4 = banner shown, 6 = finished) once the
    // configuration has arrived. Any advance beyond 1 is progress.
    function cmpVendorStatusAdvanced() {
        try {
            var cmpVendorObject = window.cmpmngr;
            if (cmpVendorObject && typeof cmpVendorObject.status === 'number' && cmpVendorObject.status > 1) {
                return true;
            }
        } catch (statusError) {
            return false;
        }
        return false;
    }

    // Milliseconds since the page's time origin, on the same clock as the
    // resource timeline entries.
    function millisecondsSincePageStart() {
        try {
            if (window.performance && typeof window.performance.now === 'function') {
                return window.performance.now();
            }
        } catch (performanceError) {
            return 0;
        }
        return 0;
    }

    // Marks the CMP as genuinely working for this visitor and stands the
    // watchdog down permanently. Called on any progress signal.
    function markCmpHealthy(reason) {
        if (watchdogState.cmpHealthy) {
            return;
        }
        watchdogState.cmpHealthy = true;
        stopProgressPoll();
        if (watchdogState.takenOver) {
            logWatchdog('real CMP asserted itself after a takeover (' + reason + '); synthetic answers withdrawn, proxy back to pass-through.');
        } else {
            logWatchdog('CMP is progressing on its own (' + reason + '); watchdog stood down.');
        }
    }

    function stopProgressPoll() {
        if (progressPollTimer !== null) {
            clearInterval(progressPollTimer);
            progressPollTimer = null;
        }
    }

    // One evaluation of the CMP's progress; runs every
    // CMP_WATCHDOG_POLL_MILLISECONDS until a decision is reached.
    function evaluateCmpProgress() {
        if (watchdogState.cmpFinal || watchdogState.cmpHealthy || watchdogState.takenOver) {
            stopProgressPoll();
            return;
        }

        if (cmpVendorStatusAdvanced()) {
            markCmpHealthy('cmpmngr.status advanced past 1');
            return;
        }

        var networkActivity = inspectCmpNetworkActivity();
        if (networkActivity.designFileRequested) {
            markCmpHealthy('design file requested');
            return;
        }

        var elapsedSinceInstall = nowMilliseconds() - proxyInstalledAtMilliseconds;

        if (networkActivity.configCallCompletedAt !== null) {
            var sinceConfigCall = millisecondsSincePageStart() - networkActivity.configCallCompletedAt;
            if (sinceConfigCall >= CMP_NO_DESIGN_CONFIRM_MILLISECONDS) {
                takeOver('cmp.php completed ' + Math.round(sinceConfigCall) + 'ms ago and no design file followed (empty configuration for this visitor)');
                return;
            }
        }

        if (elapsedSinceInstall >= CMP_WATCHDOG_MAX_WAIT_MILLISECONDS) {
            takeOver('no CMP progress of any kind within ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms (vendor unreachable)');
            return;
        }
    }

    // A minimal but complete TCData object representing "GDPR does not apply".
    // Consumers only read gdprApplies/eventStatus/cmpStatus in this case, but
    // the usual containers are present so nothing trips over a missing field.
    function buildSyntheticTcData() {
        return {
            // Marker so the watchdog's own observers can tell a synthetic
            // answer from a genuine CMP recovery; harmless extra field for
            // every other TCF consumer.
            syntheticWatchdogAnswer: true,
            tcString: '',
            tcfPolicyVersion: 4,
            cmpId: 31,
            cmpVersion: 1,
            gdprApplies: false,
            eventStatus: 'tcloaded',
            cmpStatus: 'loaded',
            isServiceSpecific: true,
            useNonStandardTexts: false,
            publisherCC: 'RS',
            purposeOneTreatment: false,
            listenerId: null,
            purpose: { consents: {}, legitimateInterests: {} },
            vendor: { consents: {}, legitimateInterests: {} },
            specialFeatureOptins: {},
            publisher: {
                consents: {},
                legitimateInterests: {},
                customPurpose: { consents: {}, legitimateInterests: {} },
                restrictions: {}
            }
        };
    }

    function answerListenerSynthetically(listenerEntry) {
        var syntheticData = buildSyntheticTcData();
        syntheticData.listenerId = listenerEntry.syntheticListenerId;
        try {
            listenerEntry.callback(syntheticData, true);
        } catch (listenerError) {
            logWatchdog('a TCF listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    // After a takeover, the proxy can only answer consumers that registered
    // THROUGH it. A consumer that registered before this file executed (GPT's
    // pubads implementation wins that race on some page loads) left its
    // callback inside the real CMP's own registry, forever waiting -- the
    // proxy cannot reach it. For the consentmanager CMP specifically, that
    // registry is publicly reachable at window.cmpmngr.api.events as entries
    // of shape { type: 'tcfv2', listener: function, id: number }, so the
    // watchdog answers those held listeners directly as well. Every step is
    // guarded: any unexpected shape (different CMP vendor, changed internals
    // after a consentmanager update) simply skips the rescue and the proxy
    // path still covers consumers that registered normally. A consumer that
    // registered through the proxy also appears in this registry and will
    // receive the synthetic answer twice; TCF listeners are event streams and
    // both GPT and Prebid handle a repeated final event idempotently.
    // Registry entries already answered, keyed by the CMP's own listener id, so
    // retries never answer the same consumer twice.
    var rescuedRegistryIds = {};

    function rescueCmpHeldListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'tcfv2' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (rescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                rescuedRegistryIds[registryEntry.id] = true;
                var syntheticData = buildSyntheticTcData();
                syntheticData.listenerId = registryEntry.id;
                try {
                    registryEntry.listener(syntheticData, true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held TCF listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('CMP-held listener rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    // The registry (window.cmpmngr) belongs to the CMP's full code, which loads
    // over the network and can appear AFTER the takeover fired -- and consumers
    // held in the CMP's stub queue only land in the registry when that code
    // processes the queue. A single rescue pass at takeover therefore misses
    // late arrivals (verified live on 03.09.2026: same build freed GPT on one
    // site and missed it on the other purely by load timing). So the rescue
    // repeats every second for a while after takeover, answering each newly
    // appeared captive listener exactly once, and stops early if the CMP
    // genuinely recovers or asserts itself.
    var CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS = 1000;
    var CMP_RESCUE_MAX_DURATION_MILLISECONDS = 30000;


    // Ad requests that GPT attempted WHILE it was still consent-blocked are
    // dropped, not queued -- freeing GPT afterwards does not resend them
    // (verified live on 03.09.2026: one site's request timing landed after the
    // rescue and rendered, the other site's landed before it and stayed blank
    // with zero gampad requests). So after the first rescue pass that actually
    // freed listeners, wait a moment and check whether ANY ad request has left
    // the page; if none has, issue a single recovery refresh of all GPT slots.
    // The completed Prebid auctions' targeting is already set on the slots, so
    // the recovery request serves with full header-bidding competition.
    // Never issued once the real CMP has asserted itself: for that visitor
    // ad requests must wait for the real consent outcome.
    var gptRedispatchScheduled = false;

    function scheduleGptRedispatchIfSilent() {
        if (gptRedispatchScheduled) {
            return;
        }
        gptRedispatchScheduled = true;
        setTimeout(function () {
            try {
                if (!syntheticAnswersActive()) {
                    logWatchdog('real CMP is in charge; recovery refresh not issued.');
                    return;
                }
                var observedAdRequestCount = 0;
                try {
                    var resourceEntries = [];
                    if (window.performance && typeof window.performance.getEntriesByType === 'function') {
                        resourceEntries = window.performance.getEntriesByType('resource');
                    }
                    var entryIndex;
                    for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                        if (String(resourceEntries[entryIndex].name).indexOf('gampad/ads') !== -1) {
                            observedAdRequestCount = observedAdRequestCount + 1;
                        }
                    }
                } catch (performanceError) {
                    observedAdRequestCount = 0;
                }
                if (observedAdRequestCount > 0) {
                    logWatchdog('GPT already dispatched ' + observedAdRequestCount + ' ad request(s); no recovery refresh needed.');
                    return;
                }
                // 13102026 (Alo): the wrapper re-sends its own first-screen slots.
                // A blanket refresh() would also request every lazy slot far
                // below the fold at once.
                if (typeof window.__aloAdsRecoveryRefresh === 'function') {
                    window.__aloAdsRecoveryRefresh();
                    logWatchdog('GPT sent no ad requests while consent was blocked; asked the wrapper to re-send its first-screen slots.');
                    return;
                }
                if (window.googletag && window.googletag.cmd) {
                    window.googletag.cmd.push(function () {
                        window.googletag.pubads().refresh();
                    });
                    logWatchdog('GPT sent no ad requests while consent was blocked; issued a one-time recovery refresh of all slots.');
                }
            } catch (redispatchError) {
                logWatchdog('GPT recovery refresh skipped: ' + redispatchError);
            }
        }, 1500);
    }

    function startCmpRegistryRescueLoop() {
        var firstPassCount = rescueCmpHeldListeners() + rescueGppRegistryListeners();
        if (firstPassCount > 0) {
            logWatchdog('rescued ' + firstPassCount + ' listener(s) held inside the CMP registry (consumers that registered before this file executed).');
            scheduleGptRedispatchIfSilent();
        }
        var elapsedMilliseconds = 0;
        var rescueTimer = setInterval(function () {
            if (!syntheticAnswersActive()) {
                clearInterval(rescueTimer);
                return;
            }
            var passCount = rescueCmpHeldListeners() + rescueGppRegistryListeners();
            if (passCount > 0) {
                logWatchdog('rescued ' + passCount + ' more CMP-held listener(s) on a retry pass.');
                scheduleGptRedispatchIfSilent();
            }
            elapsedMilliseconds = elapsedMilliseconds + CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS;
            if (elapsedMilliseconds >= CMP_RESCUE_MAX_DURATION_MILLISECONDS) {
                clearInterval(rescueTimer);
            }
        }, CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS);
    }

    // Marks the CMP as finished and stands the watchdog down. Called whenever a
    // real final event is observed through the proxy.
    function markCmpFinal() {
        if (watchdogState.cmpFinal) {
            return;
        }
        watchdogState.cmpFinal = true;
        stopProgressPoll();
        logWatchdog('CMP reached a final state on its own; watchdog stood down.');
    }

    function takeOver(reason) {
        if (watchdogState.takenOver || watchdogState.cmpFinal || watchdogState.cmpHealthy) {
            return;
        }
        stopProgressPoll();

        // Fail-safe: never bypass consent for a device that is clearly in the
        // EEA. For that visitor the watchdog does nothing at all.
        if (deviceLooksEea()) {
            watchdogState.timezoneBlocked = true;
            logWatchdog('CMP looks broken (' + reason + ') but the device timezone is ' + watchdogState.timezone +
                ' (EEA); leaving consent to the real CMP, no synthetic answer for this visitor.');
            return;
        }

        watchdogState.takenOver = true;
        watchdogState.takeoverReason = reason;
        logWatchdog(
            'taking over: ' + reason + '; answering ' + proxiedListeners.length +
            ' registered TCF listener(s) with gdprApplies=false so ad serving can proceed.');
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < proxiedListeners.length; listenerIndex++) {
            answerListenerSynthetically(proxiedListeners[listenerIndex]);
        }
        takeOverGpp();
        startCmpRegistryRescueLoop();
    }

    // Watches a real CMP event. Final states per the TCF spec are "tcloaded"
    // (no UI needed) and "useractioncomplete" (user answered the banner).
    // "cmpuishown" is not final but proves the CMP is configured and working
    // for this visitor, so it counts as the CMP asserting itself.
    function observeRealEvent(tcData) {
        // A synthetic answer produced by this watchdog (delivered back to us
        // through the CMP registry rescue) must never count as the CMP
        // recovering -- only genuine CMP events may stand the watchdog down.
        if (tcData && tcData.syntheticWatchdogAnswer) {
            return;
        }
        if (!tcData) {
            return;
        }
        if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
            markCmpHealthy('real final event ' + tcData.eventStatus);
            markCmpFinal();
            return;
        }
        if (tcData.eventStatus === 'cmpuishown' || tcData.cmpStatus === 'loaded') {
            markCmpHealthy('real event ' + tcData.eventStatus + ' / cmpStatus ' + tcData.cmpStatus);
        }
    }



    // Consumers inside iframes -- and, on some pages, GPT itself -- talk to
    // the CMP through the TCF postMessage protocol aimed at the
    // __tcfapiLocator frame instead of calling window.__tcfapi directly.
    // Those requests never pass through the function proxy above, so after a
    // takeover the watchdog answers them here as well. Verified live on sd.rs
    // (03.09.2026): GPT bound itself to the postMessage path and stayed
    // blocked even after the function-path rescue -- __tcfapiCall messages
    // flowed with ZERO __tcfapiReturn replies from the broken CMP. While the
    // CMP is healthy (or before a takeover) this responder stays silent, and
    // it stands down permanently if the real CMP asserts itself.
    function installPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__tcfapiCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__tcfapiCall || !messageEvent.source) {
                return;
            }
            var tcfCall = payload.__tcfapiCall;
            var returnValue;
            if (tcfCall.command === 'ping') {
                returnValue = {
                    gdprApplies: false,
                    cmpLoaded: true,
                    cmpStatus: 'loaded',
                    displayStatus: 'disabled',
                    apiVersion: '2.2',
                    cmpId: 31
                };
            } else {
                returnValue = buildSyntheticTcData();
            }
            var reply = { __tcfapiReturn: { returnValue: returnValue, success: true, callId: tcfCall.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            // A consumer reached through this path may also have had its ad
            // requests dropped while blocked; make sure the one-time recovery
            // refresh check runs for this path too.
            if (tcfCall.command === 'addEventListener' || tcfCall.command === 'getTCData') {
                scheduleGptRedispatchIfSilent();
            }
        }, false);
    }

    // =========================================================================
    // GPP (GLOBAL PRIVACY PLATFORM) WATCHDOG
    // =========================================================================
    //
    // The same broken CMP that blocks TCF also implements a second, independent
    // consent signal API: GPP (Global Privacy Platform, used for US state
    // privacy laws and other non-EU frameworks). It fails identically:
    // window.__gpp answers every query with cmpStatus "loading" and
    // signalStatus "not ready" forever. Google Publisher Tag consults GPP in
    // addition to TCF before it will request ads, so even after the TCF
    // watchdog above frees GPT, a stuck GPP signal can still block ad serving
    // on its own. Confirmed live on sd.rs on 03.09.2026: TCF was fully
    // resolved (registry rescue answered every tcfv2 listener, prebid ran a
    // complete auction), yet zero ad requests ever fired until GPP was also
    // freed here.
    //
    // Mirrors the TCF watchdog's three surfaces -- the window.__gpp function,
    // the consentmanager registry (entries with type 'gpp'), and the
    // postMessage protocol via the __gppLocator frame -- and fires on the same
    // takeover as TCF. A healthy GPP resolves on its own and this code never
    // engages.

    var gppRealApi = null;
    var gppProxiedListeners = [];
    var gppNextSyntheticListenerId = 300000;
    var gppRescuedRegistryIds = {};

    // A resolved-and-nothing-applies GPP signal: no section of any privacy
    // framework currently applies, which is the correct declaration when the
    // audience is not covered by the regulations GPP encodes (this wrapper's
    // watchdog already declares the TCF/GDPR equivalent above for the same
    // non-EEA audience).
    function buildSyntheticGppPingData() {
        return {
            gppVersion: '1.1',
            cmpStatus: 'loaded',
            cmpDisplayStatus: 'hidden',
            signalStatus: 'ready',
            supportedAPIs: [],
            cmpId: 31,
            sectionList: [],
            applicableSections: [],
            gppString: '',
            parsedSections: {}
        };
    }

    // GPP's addEventListener callback receives an "event" object, not the ping
    // data directly. Different integrations read either event.data (spec says
    // a plain 'ready' string for the signalStatus event) or the ping-shaped
    // fields nested under event.pingData -- both are populated here, same
    // belt-and-braces approach as the TCF synthetic answer above.
    function buildSyntheticGppEvent(listenerId) {
        return {
            eventName: 'signalStatus',
            listenerId: listenerId,
            data: 'ready',
            pingData: buildSyntheticGppPingData()
        };
    }

    function answerGppListenerSynthetically(listenerEntry) {
        try {
            listenerEntry.callback(buildSyntheticGppEvent(listenerEntry.syntheticListenerId), true);
        } catch (listenerError) {
            logWatchdog('a GPP listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    function takeOverGpp() {
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < gppProxiedListeners.length; listenerIndex++) {
            answerGppListenerSynthetically(gppProxiedListeners[listenerIndex]);
        }
        rescueGppRegistryListeners();
    }

    // Same shape as the TCF registry rescue, filtered to type 'gpp' entries;
    // deduped by registry id so a repeat retry pass never answers twice.
    function rescueGppRegistryListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'gpp' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (gppRescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                gppRescuedRegistryIds[registryEntry.id] = true;
                try {
                    registryEntry.listener(buildSyntheticGppEvent(registryEntry.id), true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held GPP listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('GPP registry rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    function installGppProxy() {
        if (typeof window.__gpp !== 'function') {
            return;
        }
        gppRealApi = window.__gpp;

        window.__gpp = function proxiedGpp(command, callback, parameter) {

            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: gppNextSyntheticListenerId
                };
                gppNextSyntheticListenerId = gppNextSyntheticListenerId + 1;
                gppProxiedListeners.push(listenerEntry);

                if (syntheticAnswersActive()) {
                    answerGppListenerSynthetically(listenerEntry);
                }

                gppRealApi(command, function (event, success) {
                    if (syntheticAnswersActive()) {
                        return;
                    }
                    callback(event, success);
                }, parameter);
                return;
            }

            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < gppProxiedListeners.length; entryIndex++) {
                    if (gppProxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        gppProxiedListeners.splice(entryIndex, 1);
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return;
                    }
                }
                gppRealApi(command, callback, parameter);
                return;
            }

            if (syntheticAnswersActive()) {
                if (typeof callback === 'function') {
                    callback(buildSyntheticGppPingData(), true);
                    return;
                }
                return;
            }

            gppRealApi(command, callback, parameter);
        };
    }

    // Consumers reaching GPP through postMessage (__gppCall / __gppReturn via
    // the __gppLocator frame), same reasoning as the TCF postMessage responder
    // above: some consumers, including GPT itself on some page loads, never
    // call window.__gpp directly.
    function installGppPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__gppCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__gppCall || !messageEvent.source) {
                return;
            }
            var gppCallInfo = payload.__gppCall;
            var returnValue = gppCallInfo.command === 'addEventListener'
                ? buildSyntheticGppEvent(gppCallInfo.callId)
                : buildSyntheticGppPingData();
            var reply = { __gppReturn: { returnValue: returnValue, success: true, callId: gppCallInfo.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            scheduleGptRedispatchIfSilent();
        }, false);
    }


    function installProxy() {
        realTcfApi = window.__tcfapi;
        watchdogState.wrapped = true;
        installPostMessageResponder();
        installGppProxy();
        installGppPostMessageResponder();

        window.__tcfapi = function proxiedTcfApi(command, version, callback, parameter) {

            // --- addEventListener -------------------------------------------
            // Record the consumer so the watchdog can answer it on takeover,
            // and ALWAYS forward the registration to the real CMP so that a
            // healthy (or later-asserting) CMP drives the consumer normally.
            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: nextSyntheticListenerId
                };
                nextSyntheticListenerId = nextSyntheticListenerId + 1;
                proxiedListeners.push(listenerEntry);

                if (syntheticAnswersActive()) {
                    // Late consumer after takeover: answer immediately so it
                    // never hangs, and still register with the real CMP below
                    // in case it asserts itself.
                    answerListenerSynthetically(listenerEntry);
                }

                realTcfApi(command, version, function (tcData, success) {
                    observeRealEvent(tcData);
                    // While synthetic answers are in force, suppress the CMP's
                    // eternal "loading" pings; only real progress is worth
                    // forwarding then (and observeRealEvent just lifted the
                    // suppression if this event was real progress).
                    if (syntheticAnswersActive()) {
                        return;
                    }
                    callback(tcData, success);
                }, parameter);
                return;
            }

            // --- removeEventListener ----------------------------------------
            // If the id is one of the watchdog's synthetic ids, confirm the
            // removal locally (the real CMP has never heard of that id).
            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < proxiedListeners.length; entryIndex++) {
                    if (proxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        proxiedListeners.splice(entryIndex, 1);
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return;
                    }
                }
                realTcfApi(command, version, callback, parameter);
                return;
            }

            // --- getTCData / ping / everything else -------------------------
            // While synthetic answers are in force, answer one-shot queries
            // synthetically (the real CMP would only ever say "loading"
            // again). Otherwise pure pass-through, with a peek at the answer
            // to spot progress or a final state.
            if (syntheticAnswersActive()) {
                if (command === 'ping' && typeof callback === 'function') {
                    callback({
                        gdprApplies: false,
                        cmpLoaded: true,
                        cmpStatus: 'loaded',
                        displayStatus: 'disabled',
                        apiVersion: '2.2',
                        cmpId: 31
                    }, true);
                    return;
                }
                if (typeof callback === 'function') {
                    callback(buildSyntheticTcData(), true);
                    return;
                }
                return;
            }

            realTcfApi(command, version, function (tcData, success) {
                observeRealEvent(tcData);
                if (typeof callback === 'function') {
                    callback(tcData, success);
                }
            }, parameter);
        };

        // The watchdog's own observer: register with the real CMP so progress
        // or a final state is noticed even if no other consumer ever registers.
        realTcfApi('addEventListener', 2, function (tcData, success) {
            if (success !== false) {
                observeRealEvent(tcData);
            }
        });

        proxyInstalledAtMilliseconds = nowMilliseconds();
        progressPollTimer = setInterval(evaluateCmpProgress, CMP_WATCHDOG_POLL_MILLISECONDS);
        logWatchdog('proxy installed; watching CMP progress (takeover ' + CMP_NO_DESIGN_CONFIRM_MILLISECONDS +
            'ms after an empty configuration answer, or after ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms without any progress).');
    }

    // The CMP stub normally exists before this file runs; if not, poll for a
    // while in case the template loads it late. No CMP at all means nothing
    // blocks ad serving, so the watchdog simply never engages.
    if (typeof window.__tcfapi === 'function') {
        installProxy();
    } else {
        var appearanceWaitedMilliseconds = 0;
        var appearancePollTimer = setInterval(function () {
            if (typeof window.__tcfapi === 'function') {
                clearInterval(appearancePollTimer);
                installProxy();
                return;
            }
            appearanceWaitedMilliseconds = appearanceWaitedMilliseconds + CMP_APPEARANCE_POLL_MILLISECONDS;
            if (appearanceWaitedMilliseconds >= CMP_APPEARANCE_MAX_WAIT_MILLISECONDS) {
                clearInterval(appearancePollTimer);
                logWatchdog('no __tcfapi appeared within ' + CMP_APPEARANCE_MAX_WAIT_MILLISECONDS + 'ms; nothing to guard.');
            }
        }, CMP_APPEARANCE_POLL_MILLISECONDS);
    }
})();

// =============================================================================
// end of the embedded TCF CMP WATCHDOG
// =============================================================================

function getCurrentPrebidLabels() {
  var width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth ||
    0;

  return width >= 1024 ? ["desktop"] : ["mobile"];
}

function applyQueryDebugOverrides() {
  var lazyLoad = normalizePxQueryValue(
    getFirstQueryParam(["adsLazy", "adLazy", "lazy", "lazyLoad"]),
  );
  var viewability = normalizeViewabilityQueryValue(
    getFirstQueryParam(["adsViewability", "adViewability", "refreshViewability"]),
  );
  var prebidTimeout = normalizeSecondsQueryValue(
    getFirstQueryParam(["adsPrebidTimeout", "prebidTimeout"]),
  );
  var refreshAll = normalizeSecondsQueryValue(
    getFirstQueryParam(["adsRefresh", "adRefresh", "refresh"]),
  );
  var stickyRefresh = normalizeSecondsQueryValue(
    getFirstQueryParam(["adsStickyRefresh", "stickyRefresh"]),
  );
  var billboardRefresh = normalizeSecondsQueryValue(
    getFirstQueryParam(["adsBillboardRefresh", "billboardRefresh"]),
  );

  if (lazyLoad !== null) {
    DISTANCE_IN_PIXELS_FOR_LAZY_LOADING = lazyLoad;
  }

  if (viewability !== null) {
    VISIBILITY_PERCENT_FOR_REFRESH = viewability;
  }

  if (prebidTimeout !== null) {
    PREBID_TIMEOUT = prebidTimeout;
  }

  if (refreshAll !== null) {
    SECONDS_TO_WAIT_AFTER_VIEWABILITY = refreshAll;
  }

  if (stickyRefresh !== null) {
    REFRESH_INTERVAL_SECONDS_BY_ADUNIT.Adhesion = stickyRefresh;
  }

  if (billboardRefresh !== null) {
    REFRESH_INTERVAL_SECONDS_BY_ADUNIT.Billboard = billboardRefresh;
  }

  window.aloAdsDebugSettings = {
    debug: ADS_DEBUG,
    prebidTimeout: PREBID_TIMEOUT,
    lazyLoad: DISTANCE_IN_PIXELS_FOR_LAZY_LOADING,
    refreshViewability: VISIBILITY_PERCENT_FOR_REFRESH,
    defaultRefreshSeconds: SECONDS_TO_WAIT_AFTER_VIEWABILITY,
    refreshIntervalSecondsByAdUnit: REFRESH_INTERVAL_SECONDS_BY_ADUNIT,
    noRefreshAdUnits: GAM_NOREFRESH_ADUNITS,
  };

  adsDebugLog("settings", window.aloAdsDebugSettings);
}

applyQueryDebugOverrides();

function getRefreshIntervalSeconds(slotElementId) {
  return (
    REFRESH_INTERVAL_SECONDS_BY_ADUNIT[slotElementId] ||
    SECONDS_TO_WAIT_AFTER_VIEWABILITY
  );
}

function runWrapper() {
  var o = document.querySelectorAll(".wrapperAd");

  function compactSlots(slots) {
    return slots.filter(function (slot) {
      return !!slot;
    });
  }

  function getRefreshBucket(refreshCount) {
    var count = parseInt(refreshCount, 10) || 0;

    if (count <= 0) {
      return "initial";
    }
    if (count === 1) {
      return "r1";
    }
    if (count === 2) {
      return "r2";
    }
    if (count === 3) {
      return "r3";
    }
    if (count <= 5) {
      return "r4_5";
    }
    if (count <= 10) {
      return "r6_10";
    }
    if (count <= 20) {
      return "r11_20";
    }

    return "r21_plus";
  }

  function safeSetPrebidTargeting(adUnitCodes) {
    try {
      if (window.pbjs && typeof pbjs.setTargetingForGPTAsync === "function") {
        pbjs.setTargetingForGPTAsync(adUnitCodes);
      }
    } catch (error) {
      // Targeting is useful, but it must never block GPT refresh.
    }
  }

  function safeRefresh(slots) {
    var slotsToRefresh = compactSlots(slots);

    if (!slotsToRefresh.length) {
      return;
    }

    googletag.cmd.push(function () {
      googletag.pubads().refresh(slotsToRefresh);
    });
  }

  function getBtfSlotByCode(adUnitCode) {
    var slotsByCode = {
      Billboard_2: Billboard_2,
      P2: P2,
      P3: P3,
      P4: P4,
      P5: P5,
      P6: P6,
      P7: P7,
      P8: P8,
      P9: P9,
      P10: P10,
      P11: P11,
      P12: P12,
      InFeed_2: InFeed_2,
      InFeed_3: InFeed_3,
      InFeed_4: InFeed_4,
      InFeed_5: InFeed_5,
      InText_2: InText_2,
      InText_3: InText_3,
      InText_4: InText_4,
      InText_5: InText_5,
    };

    return slotsByCode[adUnitCode];
  }

  function requestBidsForLazySlot(adUnitCode) {
    var refreshed = false;

    adsDebugLog("lazy slot auction", adUnitCode);

    function refreshOnce() {
      if (refreshed) {
        return;
      }

      refreshed = true;
      adsDebugLog("lazy slot refresh", adUnitCode);
      safeRefresh([getBtfSlotByCode(adUnitCode)]);
    }

    var fallbackTimer = setTimeout(refreshOnce, PREBID_TIMEOUT + 300);

    try {
      if (!window.pbjs || !pbjs.que || typeof pbjs.que.push !== "function") {
        clearTimeout(fallbackTimer);
        refreshOnce();
        return;
      }

      pbjs.que.push(function () {
        if (typeof pbjs.requestBids !== "function") {
          clearTimeout(fallbackTimer);
          refreshOnce();
          return;
        }

        pbjs.requestBids({
          timeout: PREBID_TIMEOUT,
          labels: getCurrentPrebidLabels(),
          adUnitCodes: [adUnitCode],
          bidsBackHandler: function () {
            clearTimeout(fallbackTimer);
            safeSetPrebidTargeting([adUnitCode]);
            refreshOnce();
          },
        });
      });
    } catch (error) {
      clearTimeout(fallbackTimer);
      refreshOnce();
    }
  }

  // The first-screen slots: requested once, together, in the initial GPT
  // request (initAdserver) after the first-screen Prebid auction.
  function getInitialGptSlots() {
    return [
      Adhesion,
      Billboard,
      Branding_Left,
      Branding_Right,
      P1,
      InFeed_1,
      InText_1,
    ];
  }

  function initAdserver() {
    if (pbjs.initAdserverSet) {
      return;
    }

    pbjs.initAdserverSet = true;
    adsDebugLog("initial adserver refresh");

    googletag.cmd.push(function () {
      safeSetPrebidTargeting();
      safeRefresh(getInitialGptSlots());
    });
  }

  // 13102026: used by the embedded CMP watchdog after an outage takeover, when
  // GPT dropped the first-screen request while consent was blocked.
  window.__aloAdsRecoveryRefresh = function () {
    adsDebugLog("cmp watchdog recovery refresh of the first-screen slots");

    googletag.cmd.push(function () {
      safeSetPrebidTargeting();
      safeRefresh(getInitialGptSlots());
    });
  };

  // 13102026: LAZY OBSERVER GUARD.
  // True only for a slot that this wrapper loads lazily: its Prebid ad unit is
  // in adUnitsBTF (the lazy auction + refresh in requestBidsForLazySlot). The
  // template also puts "lazyAd" on first-screen slots (InText_1, InFeed_1 on
  // category pages); those are in adUnitsATF and already requested at load, so
  // a lazy auction for them would never be followed by an ad request.
  function isLazyLoadedSlotCode(adUnitCode) {
    if (!adUnitCode) {
      return false;
    }

    for (var unitIndex = 0; unitIndex < adUnitsBTF.length; unitIndex++) {
      if (adUnitsBTF[unitIndex].code === adUnitCode) {
        return true;
      }
    }

    return false;
  }

  // 13102026: tag values for the articleTags key. The template writes
  // adsKeywords.tags (array); articleTags is read first in case it is ever set.
  function getArticleTagValues(keywords) {
    var rawTags = keywords.articleTags;

    if (rawTags === undefined || rawTags === null) {
      rawTags = keywords.tags;
    }

    if (rawTags === undefined || rawTags === null) {
      return [];
    }

    if (!Array.isArray(rawTags)) {
      rawTags = String(rawTags).split(",");
    }

    var tagValues = [];

    for (var tagIndex = 0; tagIndex < rawTags.length; tagIndex++) {
      var tagValue = String(rawTags[tagIndex]).trim();

      if (tagValue !== "") {
        tagValues.push(tagValue);
      }
    }

    return tagValues;
  }

  // 13102026: collects the page-level key-values (same keys and values as the
  // 06072026 build, plus the articleTags fix) into one object.
  function collectPageLevelTargeting() {
    var targeting = {};

    if (typeof adsKeywords !== "undefined") {
      if (adsKeywords.category !== undefined) {
        targeting.category = adsKeywords.category;
      }

      if (adsKeywords.subcategory !== undefined) {
        targeting.subcategory = adsKeywords.subcategory;
      }

      if (adsKeywords.pageType !== undefined) {
        targeting.pageType = adsKeywords.pageType;
      }

      if (adsKeywords.articleId !== undefined) {
        targeting.articleId = [adsKeywords.articleId].join(",");
      }

      var articleTagValues = getArticleTagValues(adsKeywords);

      if (articleTagValues.length > 0) {
        targeting.articleTags = articleTagValues;
      }
    }

    var adTestValue = getFirstQueryParam(["adTest"]);

    if (adTestValue !== null) {
      targeting.adTest = adTestValue;
    }

    if (ADS_DEBUG) {
      targeting.ads_debug = "1";
    }

    targeting.ads_lazy = DISTANCE_IN_PIXELS_FOR_LAZY_LOADING;
    targeting.ads_viewability = String(VISIBILITY_PERCENT_FOR_REFRESH);

    return targeting;
  }

  // 13102026: page-level targeting through googletag.setConfig (the
  // pubads().setTargeting route is deprecated). Must run inside googletag.cmd.
  function applyPageLevelTargeting() {
    var targeting = collectPageLevelTargeting();

    adsDebugLog("page-level targeting", targeting);

    if (typeof googletag.setConfig === "function") {
      googletag.setConfig({ targeting: targeting });
      return;
    }

    var keys = Object.keys(targeting);

    for (var keyIndex = 0; keyIndex < keys.length; keyIndex++) {
      googletag.pubads().setTargeting(keys[keyIndex], targeting[keys[keyIndex]]);
    }
  }

  // 13102026: PREBID-FIRST BOOT, part 1. Builds adUnitsATF / adUnitsBTF from
  // the page's .wrapperAd divs WITHOUT GPT. This is the 06072026 slot loop
  // with every googletag.defineSlot(...) assignment replaced by "void 0"
  // (generated mechanically; the GPT copy inside googletag.cmd below is the
  // same loop with every adUnitsATF/adUnitsBTF push replaced by "void 0").
  // Branch conditions (div id, adWindowWidth) are identical in both copies.
  function buildPrebidAdUnits() {
    o.forEach(function (e) {
      "Adhesion" === e.id
        ? ((void 0),
          adUnitsATF.push({
            code: "Adhesion",
            mediaTypes: {
              banner: {
                sizeConfig: [
                  {
                    minViewPort: [1600, 0],
                    sizes: [
                      [728, 90],
                      [970, 90],
                      [750, 100],
                      [750, 200],
                    ],
                  },
                  {
                    minViewPort: [1024, 0],
                    sizes: [[728, 90]],
                  },
                  {
                    minViewPort: [469, 0],
                    sizes: [[468, 60]],
                  },
                  {
                    minViewPort: [0, 0],
                    sizes: [
                      [300, 50],
                      [320, 50],
                      [300, 100],
                      [320, 100],
                    ],
                  },
                ],
              },
            },
            bids: [
{
                bidder: "adf",
                params: {
                  mid: "1710627",
                  priceType: "net",
                },
              },
{
                bidder: "directmedia",
                params: {
                  mid: "1716088",
                  priceType: "net",
                },
              },
{
                bidder: "mediapool",
                params: {
                  mid: "1984236",
                  priceType: "net",
                },
              },
{
                bidder: "criteo",
                params: {
                  networkId: 9517,
                },
              },
{
                bidder: "eskimi",
                params: {
                  placementId: 1578,
                },
              },
{
                bidder: "ix",
                params: {
                  siteId: "1081294",
                },
              },
{
                bidder: "openx",
                params: {
                  delDomain: "ringieraxelspr-d.openx.net",
                  unit: "559525007",
                },
              },
{
                bidder: "pubmatic",
                params: {
                  publisherId: "158892",
                  adSlot: "5228580",
                },
              },
{
                bidder: "richaudience",
                params: {
                  pid: "9ItWkXmZ3u",
                  supplyType: "site",
                },
              },
{
                bidder: "rtbhouse",
                params: {
                  region: "prebid-eu",
                  publisherId: "eq7oNcAuPBmB2fDVrcVE",
                  bidfloor: 0.1,
                },
              },
{
                bidder: "rubicon",
                params: {
                  accountId: 19712,
                  siteId: 492430,
                  zoneId: 2919210,
                },
              },
{
                bidder: "smartadserver",
                params: {
                  networkId: "4527",
                  siteId: "601617",
                  pageId: "1836485",
                  formatId: "120620",
                },
              },
{
                bidder: "teads",
                params: {
                  pageId: 204237,
                  placementId: 220483,
                },
              },
              {
                bidder: "connectad",
                params: {
                  networkId: 44,
                  siteId: 23211976
                },
              },
              {
                bidder: "ogury",
                params: {
                  adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                },
                labelAny: ["desktop"],
              },
              {
                bidder: "ogury",
                params: {
                  adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                },
                labelAny: ["mobile"],
              },
            ],
          }))
        : "Billboard" === e.id
          ? ((void 0),
            adUnitsATF.push({
              code: "Billboard",
              mediaTypes: {
                banner: {
                  sizeConfig: [
                    {
                      minViewPort: [1300, 0],
                      sizes: [
                        [728, 90],
                        [970, 90],
                        [750, 100],
                        [750, 200],
                        [970, 250],
                      ],
                    },
                    {
                      minViewPort: [1024, 0],
                      sizes: [[728, 90]],
                    },
                    {
                      minViewPort: [469, 0],
                      sizes: [[468, 60]],
                    },
                    {
                      minViewPort: [0, 0],
                      sizes: [
                        [300, 50],
                        [320, 50],
                        [300, 100],
                        [320, 100],
                      ],
                    },
                  ],
                },
              },
              bids: [
{
                  bidder: "adf",
                  params: {
                    mid: "1710628",
                    priceType: "net",
                  },
                },
{
                  bidder: "directmedia",
                  params: {
                    mid: "1716351",
                    priceType: "net",
                  },
                },
{
                  bidder: "mediapool",
                  params: {
                    mid: "1984232",
                    priceType: "net",
                  },
                },
{
                  bidder: "criteo",
                  params: {
                    networkId: 9517,
                  },
                },
{
                  bidder: "eskimi",
                  params: {
                    placementId: 1578,
                  },
                },
{
                  bidder: "ix",
                  params: {
                    siteId: "1081295",
                  },
                },
{
                  bidder: "openx",
                  params: {
                    delDomain: "ringieraxelspr-d.openx.net",
                    unit: "559525008",
                  },
                },
{
                  bidder: "pubmatic",
                  params: {
                    publisherId: "158892",
                    adSlot: "5228581",
                  },
                },
{
                  bidder: "richaudience",
                  params: {
                    pid: "ZiYteCmuxS",
                    supplyType: "site",
                  },
                },
{
                  bidder: "rtbhouse",
                  params: {
                    region: "prebid-eu",
                    publisherId: "eq7oNcAuPBmB2fDVrcVE",
                    bidfloor: 0.1,
                  },
                },
{
                  bidder: "rubicon",
                  params: {
                    accountId: 19712,
                    siteId: 492430,
                    zoneId: 2919212,
                  },
                },
{
                  bidder: "smartadserver",
                  params: {
                    networkId: "4527",
                    siteId: "601617",
                    pageId: "1836485",
                    formatId: "120621",
                  },
                },
{
                  bidder: "teads",
                  params: {
                    pageId: 204237,
                    placementId: 220483,
                  },
                },
                {
                  bidder: "connectad",
                  params: {
                    networkId: 44,
                    siteId: 23211976
                  },
                },
                {
                  bidder: "ogury",
                  params: {
                    adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                  },
                  labelAny: ["desktop"],
                },
                {
                  bidder: "ogury",
                  params: {
                    adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                  },
                  labelAny: ["mobile"],
                },
              ],
            }))
          : "Billboard_2" === e.id
            ? ((void 0),
              adUnitsBTF.push({
                code: "Billboard_2",
                mediaTypes: {
                  banner: {
                    sizeConfig: [
                      {
                        minViewPort: [1300, 0],
                        sizes: [
                          [728, 90],
                          [970, 90],
                          [750, 100],
                          [750, 200],
                          [970, 250],
                        ],
                      },
                      {
                        minViewPort: [1024, 0],
                        sizes: [[728, 90]],
                      },
                      {
                        minViewPort: [469, 0],
                        sizes: [[468, 60]],
                      },
                      {
                        minViewPort: [0, 0],
                        sizes: [
                          [300, 50],
                          [320, 50],
                          [300, 100],
                          [320, 100],
                        ],
                      },
                    ],
                  },
                },
                bids: [
{
                    bidder: "adf",
                    params: {
                      mid: "1877273",
                      priceType: "net",
                    },
                  },
{
                    bidder: "directmedia",
                    params: {
                      mid: "1931523",
                      priceType: "net",
                    },
                  },
{
                    bidder: "criteo",
                    params: {
                      networkId: 9517,
                    },
                  },
{
                    bidder: "eskimi",
                    params: {
                      placementId: 1578,
                    },
                  },
{
                    bidder: "ix",
                    params: {
                      siteId: "1081770",
                    },
                  },
{
                    bidder: "openx",
                    params: {
                      delDomain: "ringieraxelspr-d.openx.net",
                      unit: "560681551",
                    },
                  },
{
                    bidder: "pubmatic",
                    params: {
                      publisherId: "158892",
                      adSlot: "5798977",
                    },
                  },
{
                    bidder: "richaudience",
                    params: {
                      pid: "2kp3OCPzlo",
                      supplyType: "site",
                    },
                  },
{
                    bidder: "rtbhouse",
                    params: {
                      region: "prebid-eu",
                      publisherId: "eq7oNcAuPBmB2fDVrcVE",
                      bidfloor: 0.1,
                    },
                  },
{
                    bidder: "rubicon",
                    params: {
                      accountId: 19712,
                      siteId: 492430,
                      zoneId: 3278374,
                    },
                  },
{
                    bidder: "smartadserver",
                    params: {
                      networkId: "4527",
                      siteId: "601617",
                      pageId: "1836485",
                      formatId: "125758",
                    },
                  },
{
                    bidder: "teads",
                    params: {
                      pageId: 204237,
                      placementId: 220483,
                    },
                  },
                  {
                    bidder: "connectad",
                    params: {
                      networkId: 44,
                      siteId: 23211976
                    },
                  },
                  {
                    bidder: "ogury",
                    params: {
                      adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                    },
                    labelAny: ["desktop"],
                  },
                  {
                    bidder: "ogury",
                    params: {
                      adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                    },
                    labelAny: ["mobile"],
                  },
                ],
              }))
            : "Branding_Left" === e.id && 1200 < adWindowWidth
              ? ((void 0),
                adUnitsATF.push({
                  code: "Branding_Left",
                  mediaTypes: {
                    banner: {
                      sizeConfig: [
                        {
                          minViewPort: [1200, 0],
                          sizes: [
                            [120, 600],
                            [160, 600],
                          ],
                        },
                        {
                          minViewPort: [0, 0],
                          sizes: [],
                        },
                      ],
                    },
                  },
                  bids: [
{
                      bidder: "adf",
                      params: {
                        mid: "1875298",
                        priceType: "net",
                      },
                    },
{
                      bidder: "directmedia",
                      params: {
                        mid: "1716090",
                        priceType: "net",
                      },
                    },
{
                      bidder: "criteo",
                      params: {
                        networkId: 9517,
                      },
                    },
{
                      bidder: "eskimi",
                      params: {
                        placementId: 1578,
                      },
                    },
{
                      bidder: "ix",
                      params: {
                        siteId: "1081296",
                      },
                    },
{
                      bidder: "openx",
                      params: {
                        delDomain: "ringieraxelspr-d.openx.net",
                        unit: "560677812",
                      },
                    },
{
                      bidder: "pubmatic",
                      params: {
                        publisherId: "158892",
                        adSlot: "5784579",
                      },
                    },
{
                      bidder: "rubicon",
                      params: {
                        accountId: 19712,
                        siteId: 464372,
                        zoneId: 3272212,
                      },
                    },
{
                      bidder: "smartadserver",
                      params: {
                        networkId: "4527",
                        siteId: "582598",
                        pageId: "1769348",
                        formatId: "120622",
                      },
                    },
{
                      bidder: "connectad",
                      params: {
                        networkId: 44,
                        siteId: 23211976
                      },
                    },
                    {
                      bidder: "ogury",
                      params: {
                        adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                      },
                      labelAny: ["desktop"],
                    },
                  ],
                }))
              : "Branding_Right" === e.id && 1200 < adWindowWidth
                ? ((void 0),
                  adUnitsATF.push({
                    code: "Branding_Right",
                    mediaTypes: {
                      banner: {
                        sizeConfig: [
                          {
                            minViewPort: [1200, 0],
                            sizes: [
                              [120, 600],
                              [160, 600],
                            ],
                          },
                          {
                            minViewPort: [0, 0],
                            sizes: [],
                          },
                        ],
                      },
                    },
                    bids: [
{
                        bidder: "adf",
                        params: {
                          mid: "1875299",
                          priceType: "net",
                        },
                      },
{
                        bidder: "directmedia",
                        params: {
                          mid: "1931526",
                          priceType: "net",
                        },
                      },
{
                        bidder: "criteo",
                        params: {
                          networkId: 9517,
                        },
                      },
{
                        bidder: "eskimi",
                        params: {
                          placementId: 1578,
                        },
                      },
{
                        bidder: "ix",
                        params: {
                          siteId: "1081297",
                        },
                      },
{
                        bidder: "openx",
                        params: {
                          delDomain: "ringieraxelspr-d.openx.net",
                          unit: "560677813",
                        },
                      },
{
                        bidder: "pubmatic",
                        params: {
                          publisherId: "158892",
                          adSlot: "5784580",
                        },
                      },
{
                        bidder: "rubicon",
                        params: {
                          accountId: 19712,
                          siteId: 464372,
                          zoneId: 3272216,
                        },
                      },
{
                        bidder: "smartadserver",
                        params: {
                          networkId: "4527",
                          siteId: "582598",
                          pageId: "1769348",
                          formatId: "120623",
                        },
                      },
{
                        bidder: "connectad",
                        params: {
                          networkId: 44,
                          siteId: 23211976
                        },
                      },
                      {
                        bidder: "ogury",
                        params: {
                          adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                        },
                        labelAny: ["desktop"],
                      },
                    ],
                  }))
                : "P1" === e.id
                  ? ((void 0),
                    adUnitsATF.push({
                      code: "P1",
                      mediaTypes: {
                        banner: {
                          sizeConfig: [
                            {
                              minViewPort: [1024, 0],
                              sizes: [
                                [200, 200],
                                [250, 250],
                                [300, 250],
                                [120, 600],
                                [160, 600],
                                [300, 600],
                              ],
                            },
                            {
                              minViewPort: [469, 0],
                              sizes: [
                                [200, 200],
                                [250, 250],
                                [300, 250],
                              ],
                            },
                            {
                              minViewPort: [0, 0],
                              sizes: [
                                [200, 200],
                                [250, 250],
                                [300, 250],
                                [336, 280],
                              ],
                            },
                          ],
                        },
                      },
                      bids: [
{
                          bidder: "adf",
                          params: {
                            mid: "1710629",
                            priceType: "net",
                          },
                        },
{
                          bidder: "directmedia",
                          params: {
                            mid: "1931500",
                            priceType: "net",
                          },
                        },
{
                          bidder: "mediapool",
                          params: {
                            mid: "1984234",
                            priceType: "net",
                          },
                        },
{
                          bidder: "criteo",
                          params: {
                            networkId: 9517,
                          },
                        },
{
                          bidder: "eskimi",
                          params: {
                            placementId: 1578,
                          },
                        },
{
                          bidder: "ix",
                          params: {
                            siteId: "1081298",
                          },
                        },
{
                          bidder: "openx",
                          params: {
                            delDomain: "ringieraxelspr-d.openx.net",
                            unit: "559525009",
                          },
                        },
{
                          bidder: "pubmatic",
                          params: {
                            publisherId: "158892",
                            adSlot: "5228582",
                          },
                        },
{
                          bidder: "richaudience",
                          params: {
                            pid: "LZGjS2mLIM",
                            supplyType: "site",
                          },
                        },
{
                          bidder: "rtbhouse",
                          params: {
                            region: "prebid-eu",
                            publisherId: "eq7oNcAuPBmB2fDVrcVE",
                            bidfloor: 0.1,
                          },
                        },
{
                          bidder: "rubicon",
                          params: {
                            accountId: 19712,
                            siteId: 492430,
                            zoneId: 2919214,
                          },
                        },
{
                          bidder: "smartadserver",
                          params: {
                            networkId: "4527",
                            siteId: "601617",
                            pageId: "1836485",
                            formatId: "120624",
                          },
                        },
{
                          bidder: "connectad",
                          params: {
                            networkId: 44,
                            siteId: 23211976
                          },
                        },
                        {
                          bidder: "ogury",
                          params: {
                            adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                          },
                          labelAny: ["desktop"],
                        },
                        {
                          bidder: "ogury",
                          params: {
                            adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                          },
                          labelAny: ["mobile"],
                        },
                      ],
                    }))
                  : "P2" === e.id
                    ? ((void 0),
                      adUnitsBTF.push({
                        code: "P2",
                        mediaTypes: {
                          banner: {
                            sizeConfig: [
                              {
                                minViewPort: [1024, 0],
                                sizes: [
                                  [200, 200],
                                  [250, 250],
                                  [300, 250],
                                  [120, 600],
                                  [160, 600],
                                  [300, 600],
                                ],
                              },
                              {
                                minViewPort: [469, 0],
                                sizes: [
                                  [200, 200],
                                  [250, 250],
                                  [300, 250],
                                ],
                              },
                              {
                                minViewPort: [0, 0],
                                sizes: [
                                  [200, 200],
                                  [250, 250],
                                  [300, 250],
                                  [336, 280],
                                ],
                              },
                            ],
                          },
                        },
                        bids: [
{
                            bidder: "adf",
                            params: {
                              mid: "1710630",
                              priceType: "net",
                            },
                          },
{
                            bidder: "directmedia",
                            params: {
                              mid: "1931527",
                              priceType: "net",
                            },
                          },
{
                            bidder: "criteo",
                            params: {
                              networkId: 9517,
                            },
                          },
{
                            bidder: "eskimi",
                            params: {
                              placementId: 1578,
                            },
                          },
{
                            bidder: "ix",
                            params: {
                              siteId: "1081299",
                            },
                          },
{
                            bidder: "openx",
                            params: {
                              delDomain: "ringieraxelspr-d.openx.net",
                              unit: "559525010",
                            },
                          },
{
                            bidder: "pubmatic",
                            params: {
                              publisherId: "158892",
                              adSlot: "5228583",
                            },
                          },
{
                            bidder: "richaudience",
                            params: {
                              pid: "C4PgTdXd3x",
                              supplyType: "site",
                            },
                          },
{
                            bidder: "rtbhouse",
                            params: {
                              region: "prebid-eu",
                              publisherId: "eq7oNcAuPBmB2fDVrcVE",
                              bidfloor: 0.1,
                            },
                          },
{
                            bidder: "rubicon",
                            params: {
                              accountId: 19712,
                              siteId: 492430,
                              zoneId: 2919216,
                            },
                          },
{
                            bidder: "smartadserver",
                            params: {
                              networkId: "4527",
                              siteId: "601617",
                              pageId: "1836485",
                              formatId: "120625",
                            },
                          },
{
                            bidder: "teads",
                            params: {
                              pageId: 204237,
                              placementId: 220483,
                            },
                          },
                          {
                            bidder: "connectad",
                            params: {
                              networkId: 44,
                              siteId: 23211976
                            },
                          },
                          {
                            bidder: "ogury",
                            params: {
                              adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                            },
                            labelAny: ["desktop"],
                          },
                          {
                            bidder: "ogury",
                            params: {
                              adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                            },
                            labelAny: ["mobile"],
                          },
                        ],
                      }))
                    : "P3" === e.id
                      ? ((void 0),
                        adUnitsBTF.push({
                          code: "P3",
                          mediaTypes: {
                            banner: {
                              sizeConfig: [
                                {
                                  minViewPort: [1024, 0],
                                  sizes: [
                                    [200, 200],
                                    [250, 250],
                                    [300, 250],
                                    [120, 600],
                                    [160, 600],
                                    [300, 600],
                                  ],
                                },
                                {
                                  minViewPort: [469, 0],
                                  sizes: [
                                    [200, 200],
                                    [250, 250],
                                    [300, 250],
                                  ],
                                },
                                {
                                  minViewPort: [0, 0],
                                  sizes: [
                                    [200, 200],
                                    [250, 250],
                                    [300, 250],
                                    [336, 280],
                                  ],
                                },
                              ],
                            },
                          },
                          bids: [
{
                              bidder: "adf",
                              params: {
                                mid: "1710631",
                                priceType: "net",
                              },
                            },
{
                              bidder: "directmedia",
                              params: {
                                mid: "1931528",
                                priceType: "net",
                              },
                            },
{
                              bidder: "criteo",
                              params: {
                                networkId: 9517,
                              },
                            },
{
                              bidder: "eskimi",
                              params: {
                                placementId: 1578,
                              },
                            },
{
                              bidder: "ix",
                              params: {
                                siteId: "1081301",
                              },
                            },
{
                              bidder: "openx",
                              params: {
                                delDomain: "ringieraxelspr-d.openx.net",
                                unit: "559525011",
                              },
                            },
{
                              bidder: "pubmatic",
                              params: {
                                publisherId: "158892",
                                adSlot: "5228584",
                              },
                            },
{
                              bidder: "richaudience",
                              params: {
                                pid: "y8OLZHijwy",
                                supplyType: "site",
                              },
                            },
{
                              bidder: "rtbhouse",
                              params: {
                                region: "prebid-eu",
                                publisherId: "eq7oNcAuPBmB2fDVrcVE",
                                bidfloor: 0.1,
                              },
                            },
{
                              bidder: "rubicon",
                              params: {
                                accountId: 19712,
                                siteId: 492430,
                                zoneId: 2919218,
                              },
                            },
{
                              bidder: "smartadserver",
                              params: {
                                networkId: "4527",
                                siteId: "601617",
                                pageId: "1836485",
                                formatId: "120626",
                              },
                            },
{
                              bidder: "teads",
                              params: {
                                pageId: 204237,
                                placementId: 220483,
                              },
                            },
                            {
                              bidder: "connectad",
                              params: {
                                networkId: 44,
                                siteId: 23211976
                              },
                            },
                            {
                              bidder: "ogury",
                              params: {
                                adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                              },
                              labelAny: ["desktop"],
                            },
                            {
                              bidder: "ogury",
                              params: {
                                adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                              },
                              labelAny: ["mobile"],
                            },
                          ],
                        }))
                      : "P4" === e.id
                        ? ((void 0),
                          adUnitsBTF.push({
                            code: "P4",
                            mediaTypes: {
                              banner: {
                                sizeConfig: [
                                  {
                                    minViewPort: [1024, 0],
                                    sizes: [
                                      [200, 200],
                                      [250, 250],
                                      [300, 250],
                                      [120, 600],
                                      [160, 600],
                                      [300, 600],
                                    ],
                                  },
                                  {
                                    minViewPort: [469, 0],
                                    sizes: [
                                      [200, 200],
                                      [250, 250],
                                      [300, 250],
                                    ],
                                  },
                                  {
                                    minViewPort: [0, 0],
                                    sizes: [
                                      [200, 200],
                                      [250, 250],
                                      [300, 250],
                                      [336, 280],
                                    ],
                                  },
                                ],
                              },
                            },
                            bids: [
{
                                bidder: "adf",
                                params: {
                                  mid: "1710632",
                                  priceType: "net",
                                },
                              },
{
                                bidder: "directmedia",
                                params: {
                                  mid: "1931530",
                                  priceType: "net",
                                },
                              },
{
                                bidder: "criteo",
                                params: {
                                  networkId: 9517,
                                },
                              },
{
                                bidder: "eskimi",
                                params: {
                                  placementId: 1578,
                                },
                              },
{
                                bidder: "ix",
                                params: {
                                  siteId: "1081302",
                                },
                              },
{
                                bidder: "openx",
                                params: {
                                  delDomain: "ringieraxelspr-d.openx.net",
                                  unit: "559525012",
                                },
                              },
{
                                bidder: "pubmatic",
                                params: {
                                  publisherId: "158892",
                                  adSlot: "5228585",
                                },
                              },
{
                                bidder: "richaudience",
                                params: {
                                  pid: "Gvuop31mkQ",
                                  supplyType: "site",
                                },
                              },
{
                                bidder: "rtbhouse",
                                params: {
                                  region: "prebid-eu",
                                  publisherId: "eq7oNcAuPBmB2fDVrcVE",
                                  bidfloor: 0.1,
                                },
                              },
{
                                bidder: "rubicon",
                                params: {
                                  accountId: 19712,
                                  siteId: 492430,
                                  zoneId: 2919220,
                                },
                              },
{
                                bidder: "smartadserver",
                                params: {
                                  networkId: "4527",
                                  siteId: "601617",
                                  pageId: "1836485",
                                  formatId: "123584",
                                },
                              },
{
                                bidder: "teads",
                                params: {
                                  pageId: 204237,
                                  placementId: 220483,
                                },
                              },
                              {
                                bidder: "connectad",
                                params: {
                                  networkId: 44,
                                  siteId: 23211976
                                },
                              },
                              {
                                bidder: "ogury",
                                params: {
                                  adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                },
                                labelAny: ["desktop"],
                              },
                              {
                                bidder: "ogury",
                                params: {
                                  adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                },
                                labelAny: ["mobile"],
                              },
                            ],
                          }))
                        : "P5" === e.id
                          ? ((void 0),
                            adUnitsBTF.push({
                              code: "P5",
                              mediaTypes: {
                                banner: {
                                  sizeConfig: [
                                    {
                                      minViewPort: [1024, 0],
                                      sizes: [
                                        [200, 200],
                                        [250, 250],
                                        [300, 250],
                                      ],
                                    },
                                    {
                                      minViewPort: [469, 0],
                                      sizes: [
                                        [200, 200],
                                        [250, 250],
                                        [300, 250],
                                      ],
                                    },
                                    {
                                      minViewPort: [0, 0],
                                      sizes: [
                                        [200, 200],
                                        [250, 250],
                                        [300, 250],
                                        [336, 280],
                                      ],
                                    },
                                  ],
                                },
                              },
                              bids: [
{
                                  bidder: "adf",
                                  params: {
                                    mid: "1875300",
                                    priceType: "net",
                                  },
                                },
{
                                  bidder: "directmedia",
                                  params: {
                                    mid: "1931534",
                                    priceType: "net",
                                  },
                                },
{
                                  bidder: "criteo",
                                  params: {
                                    networkId: 9517,
                                  },
                                },
{
                                  bidder: "eskimi",
                                  params: {
                                    placementId: 1578,
                                  },
                                },
{
                                  bidder: "ix",
                                  params: {
                                    siteId: "1081303",
                                  },
                                },
{
                                  bidder: "openx",
                                  params: {
                                    delDomain: "ringieraxelspr-d.openx.net",
                                    unit: "560677814",
                                  },
                                },
{
                                  bidder: "pubmatic",
                                  params: {
                                    publisherId: "158892",
                                    adSlot: "5784581",
                                  },
                                },
{
                                  bidder: "richaudience",
                                  params: {
                                    pid: "QpWSQKF3uN",
                                    supplyType: "site",
                                  },
                                },
{
                                  bidder: "rtbhouse",
                                  params: {
                                    region: "prebid-eu",
                                    publisherId: "eq7oNcAuPBmB2fDVrcVE",
                                    bidfloor: 0.1,
                                  },
                                },
{
                                  bidder: "rubicon",
                                  params: {
                                    accountId: 19712,
                                    siteId: 492430,
                                    zoneId: 3272220,
                                  },
                                },
{
                                  bidder: "smartadserver",
                                  params: {
                                    networkId: "4527",
                                    siteId: "601617",
                                    pageId: "1836485",
                                    formatId: "125177",
                                  },
                                },
{
                                  bidder: "teads",
                                  params: {
                                    pageId: 204237,
                                    placementId: 220483,
                                  },
                                },
                                {
                                  bidder: "connectad",
                                  params: {
                                    networkId: 44,
                                    siteId: 23211976
                                  },
                                },
                                {
                                  bidder: "ogury",
                                  params: {
                                    adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                  },
                                  labelAny: ["desktop"],
                                },
                                {
                                  bidder: "ogury",
                                  params: {
                                    adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                  },
                                  labelAny: ["mobile"],
                                },
                              ],
                            }))
                          : "P6" === e.id
                            ? ((void 0),
                              adUnitsBTF.push({
                                code: "P6",
                                mediaTypes: {
                                  banner: {
                                    sizeConfig: [
                                      {
                                        minViewPort: [1024, 0],
                                        sizes: [
                                          [200, 200],
                                          [250, 250],
                                          [300, 250],
                                        ],
                                      },
                                      {
                                        minViewPort: [469, 0],
                                        sizes: [
                                          [200, 200],
                                          [250, 250],
                                          [300, 250],
                                        ],
                                      },
                                      {
                                        minViewPort: [0, 0],
                                        sizes: [
                                          [200, 200],
                                          [250, 250],
                                          [300, 250],
                                          [336, 280],
                                        ],
                                      },
                                    ],
                                  },
                                },
                                bids: [
{
                                    bidder: "adf",
                                    params: {
                                      mid: "1875301",
                                      priceType: "net",
                                    },
                                  },
{
                                    bidder: "directmedia",
                                    params: {
                                      mid: "1931529",
                                      priceType: "net",
                                    },
                                  },
{
                                    bidder: "criteo",
                                    params: {
                                      networkId: 9517,
                                    },
                                  },
{
                                    bidder: "eskimi",
                                    params: {
                                      placementId: 1578,
                                    },
                                  },
{
                                    bidder: "ix",
                                    params: {
                                      siteId: "1081304",
                                    },
                                  },
{
                                    bidder: "openx",
                                    params: {
                                      delDomain: "ringieraxelspr-d.openx.net",
                                      unit: "560677815",
                                    },
                                  },
{
                                    bidder: "pubmatic",
                                    params: {
                                      publisherId: "158892",
                                      adSlot: "5784582",
                                    },
                                  },
{
                                    bidder: "richaudience",
                                    params: {
                                      pid: "4mJ6wdNvO3",
                                      supplyType: "site",
                                    },
                                  },
{
                                    bidder: "rtbhouse",
                                    params: {
                                      region: "prebid-eu",
                                      publisherId: "eq7oNcAuPBmB2fDVrcVE",
                                      bidfloor: 0.1,
                                    },
                                  },
{
                                    bidder: "rubicon",
                                    params: {
                                      accountId: 19712,
                                      siteId: 492430,
                                      zoneId: 3272222,
                                    },
                                  },
{
                                    bidder: "smartadserver",
                                    params: {
                                      networkId: "4527",
                                      siteId: "601617",
                                      pageId: "1836485",
                                      formatId: "125178",
                                    },
                                  },
{
                                    bidder: "teads",
                                    params: {
                                      pageId: 204237,
                                      placementId: 220483,
                                    },
                                  },
                                  {
                                    bidder: "connectad",
                                    params: {
                                      networkId: 44,
                                      siteId: 23211976
                                    },
                                  },
                                  {
                                    bidder: "ogury",
                                    params: {
                                      adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                    },
                                    labelAny: ["desktop"],
                                  },
                                  {
                                    bidder: "ogury",
                                    params: {
                                      adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                    },
                                    labelAny: ["mobile"],
                                  },
                                ],
                              }))
                            : "P7" === e.id
                              ? ((void 0),
                                adUnitsBTF.push({
                                  code: "P7",
                                  mediaTypes: {
                                    banner: {
                                      sizeConfig: [
                                        {
                                          minViewPort: [1024, 0],
                                          sizes: [
                                            [200, 200],
                                            [250, 250],
                                            [300, 250],
                                            [120, 600],
                                            [160, 600],
                                            [300, 600],
                                          ],
                                        },
                                        {
                                          minViewPort: [469, 0],
                                          sizes: [
                                            [200, 200],
                                            [250, 250],
                                            [300, 250],
                                          ],
                                        },
                                        {
                                          minViewPort: [0, 0],
                                          sizes: [
                                            [200, 200],
                                            [250, 250],
                                            [300, 250],
                                            [336, 280],
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  bids: [
{
                                      bidder: "adf",
                                      params: {
                                        mid: "1875302",
                                        priceType: "net",
                                      },
                                    },
{
                                      bidder: "directmedia",
                                      params: {
                                        mid: "1931531",
                                        priceType: "net",
                                      },
                                    },
{
                                      bidder: "criteo",
                                      params: {
                                        networkId: 9517,
                                      },
                                    },
{
                                      bidder: "eskimi",
                                      params: {
                                        placementId: 1578,
                                      },
                                    },
{
                                      bidder: "ix",
                                      params: {
                                        siteId: "1081305",
                                      },
                                    },
{
                                      bidder: "openx",
                                      params: {
                                        delDomain: "ringieraxelspr-d.openx.net",
                                        unit: "560677816",
                                      },
                                    },
{
                                      bidder: "pubmatic",
                                      params: {
                                        publisherId: "158892",
                                        adSlot: "5784583",
                                      },
                                    },
{
                                      bidder: "richaudience",
                                      params: {
                                        pid: "sffls1WCDt",
                                        supplyType: "site",
                                      },
                                    },
{
                                      bidder: "rtbhouse",
                                      params: {
                                        region: "prebid-eu",
                                        publisherId: "eq7oNcAuPBmB2fDVrcVE",
                                        bidfloor: 0.1,
                                      },
                                    },
{
                                      bidder: "rubicon",
                                      params: {
                                        accountId: 19712,
                                        siteId: 492430,
                                        zoneId: 3272224,
                                      },
                                    },
{
                                      bidder: "smartadserver",
                                      params: {
                                        networkId: "4527",
                                        siteId: "601617",
                                        pageId: "1836485",
                                        formatId: "125179",
                                      },
                                    },
{
                                      bidder: "teads",
                                      params: {
                                        pageId: 204237,
                                        placementId: 220483,
                                      },
                                    },
                                    {
                                      bidder: "connectad",
                                      params: {
                                        networkId: 44,
                                        siteId: 23211976
                                      },
                                    },
                                    {
                                      bidder: "ogury",
                                      params: {
                                        adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                      },
                                      labelAny: ["desktop"],
                                    },
                                    {
                                      bidder: "ogury",
                                      params: {
                                        adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                      },
                                      labelAny: ["mobile"],
                                    },
                                  ],
                                }))
                              : "P8" === e.id && adWindowWidth < 1e3
                                ? ((void 0),
                                  adUnitsBTF.push({
                                    code: "P8",
                                    mediaTypes: {
                                      banner: {
                                        sizeConfig: [
                                          {
                                            minViewPort: [1024, 0],
                                            sizes: [
                                              [200, 200],
                                              [250, 250],
                                              [300, 250],
                                              [120, 600],
                                              [160, 600],
                                              [300, 600],
                                            ],
                                          },
                                          {
                                            minViewPort: [469, 0],
                                            sizes: [
                                              [200, 200],
                                              [250, 250],
                                              [300, 250],
                                            ],
                                          },
                                          {
                                            minViewPort: [0, 0],
                                            sizes: [
                                              [200, 200],
                                              [250, 250],
                                              [300, 250],
                                              [336, 280],
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    bids: [
{
                                        bidder: "adf",
                                        params: {
                                          mid: "1875303",
                                          priceType: "net",
                                        },
                                      },
{
                                        bidder: "directmedia",
                                        params: {
                                          mid: "1931532",
                                          priceType: "net",
                                        },
                                      },
{
                                        bidder: "criteo",
                                        params: {
                                          networkId: 9517,
                                        },
                                      },
{
                                        bidder: "eskimi",
                                        params: {
                                          placementId: 1578,
                                        },
                                      },
{
                                        bidder: "ix",
                                        params: {
                                          siteId: "1081306",
                                        },
                                      },
{
                                        bidder: "openx",
                                        params: {
                                          delDomain:
                                            "ringieraxelspr-d.openx.net",
                                          unit: "560677817",
                                        },
                                      },
{
                                        bidder: "pubmatic",
                                        params: {
                                          publisherId: "158892",
                                          adSlot: "5784584",
                                        },
                                      },
{
                                        bidder: "richaudience",
                                        params: {
                                          pid: "oedQ37ooys",
                                          supplyType: "site",
                                        },
                                      },
{
                                        bidder: "rtbhouse",
                                        params: {
                                          region: "prebid-eu",
                                          publisherId: "eq7oNcAuPBmB2fDVrcVE",
                                          bidfloor: 0.1,
                                        },
                                      },
{
                                        bidder: "rubicon",
                                        params: {
                                          accountId: 19712,
                                          siteId: 492430,
                                          zoneId: 3272226,
                                        },
                                      },
{
                                        bidder: "smartadserver",
                                        params: {
                                          networkId: "4527",
                                          siteId: "601617",
                                          pageId: "1836485",
                                          formatId: "125180",
                                        },
                                      },
{
                                        bidder: "teads",
                                        params: {
                                          pageId: 204237,
                                          placementId: 220483,
                                        },
                                      },
                                      {
                                        bidder: "connectad",
                                        params: {
                                          networkId: 44,
                                          siteId: 23211976
                                        },
                                      },
                                      {
                                        bidder: "ogury",
                                        params: {
                                          adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                        },
                                        labelAny: ["desktop"],
                                      },
                                      {
                                        bidder: "ogury",
                                        params: {
                                          adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                        },
                                        labelAny: ["mobile"],
                                      },
                                    ],
                                  }))
                                : "P9" === e.id && adWindowWidth < 1e3
                                  ? ((void 0),
                                    adUnitsBTF.push({
                                      code: "P9",
                                      mediaTypes: {
                                        banner: {
                                          sizeConfig: [
                                            {
                                              minViewPort: [1024, 0],
                                              sizes: [
                                                [200, 200],
                                                [250, 250],
                                                [300, 250],
                                                [120, 600],
                                                [160, 600],
                                                [300, 600],
                                              ],
                                            },
                                            {
                                              minViewPort: [469, 0],
                                              sizes: [
                                                [200, 200],
                                                [250, 250],
                                                [300, 250],
                                              ],
                                            },
                                            {
                                              minViewPort: [0, 0],
                                              sizes: [
                                                [200, 200],
                                                [250, 250],
                                                [300, 250],
                                                [336, 280],
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      bids: [
{
                                          bidder: "adf",
                                          params: {
                                            mid: "1875304",
                                            priceType: "net",
                                          },
                                        },
{
                                          bidder: "directmedia",
                                          params: {
                                            mid: "1931535",
                                            priceType: "net",
                                          },
                                        },
{
                                          bidder: "criteo",
                                          params: {
                                            networkId: 9517,
                                          },
                                        },
{
                                          bidder: "eskimi",
                                          params: {
                                            placementId: 1578,
                                          },
                                        },
{
                                          bidder: "ix",
                                          params: {
                                            siteId: "1081307",
                                          },
                                        },
{
                                          bidder: "openx",
                                          params: {
                                            delDomain:
                                              "ringieraxelspr-d.openx.net",
                                            unit: "560677818",
                                          },
                                        },
{
                                          bidder: "pubmatic",
                                          params: {
                                            publisherId: "158892",
                                            adSlot: "5784585",
                                          },
                                        },
{
                                          bidder: "richaudience",
                                          params: {
                                            pid: "RkQ9stFVYn",
                                            supplyType: "site",
                                          },
                                        },
{
                                          bidder: "rtbhouse",
                                          params: {
                                            region: "prebid-eu",
                                            publisherId: "eq7oNcAuPBmB2fDVrcVE",
                                            bidfloor: 0.1,
                                          },
                                        },
{
                                          bidder: "rubicon",
                                          params: {
                                            accountId: 19712,
                                            siteId: 492430,
                                            zoneId: 3272228,
                                          },
                                        },
{
                                          bidder: "smartadserver",
                                          params: {
                                            networkId: "4527",
                                            siteId: "601617",
                                            pageId: "1836485",
                                            formatId: "126448",
                                          },
                                        },
{
                                          bidder: "teads",
                                          params: {
                                            pageId: 204237,
                                            placementId: 220483,
                                          },
                                        },
                                        {
                                          bidder: "connectad",
                                          params: {
                                            networkId: 44,
                                            siteId: 23211976
                                          },
                                        },
                                        {
                                          bidder: "ogury",
                                          params: {
                                            adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                          },
                                          labelAny: ["desktop"],
                                        },
                                        {
                                          bidder: "ogury",
                                          params: {
                                            adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                          },
                                          labelAny: ["mobile"],
                                        },
                                      ],
                                    }))
                                  : "P10" === e.id && adWindowWidth < 1e3
                                    ? ((void 0),
                                      adUnitsBTF.push({
                                        code: "P10",
                                        mediaTypes: {
                                          banner: {
                                            sizeConfig: [
                                              {
                                                minViewPort: [1024, 0],
                                                sizes: [
                                                  [200, 200],
                                                  [250, 250],
                                                  [300, 250],
                                                  [120, 600],
                                                  [160, 600],
                                                  [300, 600],
                                                ],
                                              },
                                              {
                                                minViewPort: [469, 0],
                                                sizes: [
                                                  [200, 200],
                                                  [250, 250],
                                                  [300, 250],
                                                ],
                                              },
                                              {
                                                minViewPort: [0, 0],
                                                sizes: [
                                                  [200, 200],
                                                  [250, 250],
                                                  [300, 250],
                                                  [336, 280],
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        bids: [
{
                                            bidder: "adf",
                                            params: {
                                              mid: "1875305",
                                              priceType: "net",
                                            },
                                          },
{
                                            bidder: "directmedia",
                                            params: {
                                              mid: "1931536",
                                              priceType: "net",
                                            },
                                          },
{
                                            bidder: "criteo",
                                            params: {
                                              networkId: 9517,
                                            },
                                          },
{
                                            bidder: "eskimi",
                                            params: {
                                              placementId: 1578,
                                            },
                                          },
{
                                            bidder: "ix",
                                            params: {
                                              siteId: "1081308",
                                            },
                                          },
{
                                            bidder: "openx",
                                            params: {
                                              delDomain:
                                                "ringieraxelspr-d.openx.net",
                                              unit: "560677819",
                                            },
                                          },
{
                                            bidder: "pubmatic",
                                            params: {
                                              publisherId: "158892",
                                              adSlot: "5784586",
                                            },
                                          },
{
                                            bidder: "richaudience",
                                            params: {
                                              pid: "oqe3DLE40T",
                                              supplyType: "site",
                                            },
                                          },
{
                                            bidder: "rtbhouse",
                                            params: {
                                              region: "prebid-eu",
                                              publisherId:
                                                "eq7oNcAuPBmB2fDVrcVE",
                                              bidfloor: 0.1,
                                            },
                                          },
{
                                            bidder: "rubicon",
                                            params: {
                                              accountId: 19712,
                                              siteId: 492430,
                                              zoneId: 3272232,
                                            },
                                          },
{
                                            bidder: "smartadserver",
                                            params: {
                                              networkId: "4527",
                                              siteId: "601617",
                                              pageId: "1836485",
                                              formatId: "126449",
                                            },
                                          },
{
                                            bidder: "teads",
                                            params: {
                                              pageId: 204237,
                                              placementId: 220483,
                                            },
                                          },
                                          {
                                            bidder: "connectad",
                                            params: {
                                              networkId: 44,
                                              siteId: 23211976
                                            },
                                          },
                                          {
                                            bidder: "ogury",
                                            params: {
                                              adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                            },
                                            labelAny: ["desktop"],
                                          },
                                          {
                                            bidder: "ogury",
                                            params: {
                                              adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                            },
                                            labelAny: ["mobile"],
                                          },
                                        ],
                                      }))
                                    : "P11" === e.id && adWindowWidth < 1e3
                                      ? ((void 0),
                                        adUnitsBTF.push({
                                          code: "P11",
                                          mediaTypes: {
                                            banner: {
                                              sizeConfig: [
                                                {
                                                  minViewPort: [1024, 0],
                                                  sizes: [
                                                    [200, 200],
                                                    [250, 250],
                                                    [300, 250],
                                                    [120, 600],
                                                    [160, 600],
                                                    [300, 600],
                                                  ],
                                                },
                                                {
                                                  minViewPort: [469, 0],
                                                  sizes: [
                                                    [200, 200],
                                                    [250, 250],
                                                    [300, 250],
                                                  ],
                                                },
                                                {
                                                  minViewPort: [0, 0],
                                                  sizes: [
                                                    [200, 200],
                                                    [250, 250],
                                                    [300, 250],
                                                    [336, 280],
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          bids: [
{
                                              bidder: "adf",
                                              params: {
                                                mid: "1875306",
                                                priceType: "net",
                                              },
                                            },
{
                                              bidder: "directmedia",
                                              params: {
                                                mid: "1931533",
                                                priceType: "net",
                                              },
                                            },
{
                                              bidder: "criteo",
                                              params: {
                                                networkId: 9517,
                                              },
                                            },
{
                                              bidder: "eskimi",
                                              params: {
                                                placementId: 1578,
                                              },
                                            },
{
                                              bidder: "ix",
                                              params: {
                                                siteId: "1081309",
                                              },
                                            },
{
                                              bidder: "openx",
                                              params: {
                                                delDomain:
                                                  "ringieraxelspr-d.openx.net",
                                                unit: "560677820",
                                              },
                                            },
{
                                              bidder: "pubmatic",
                                              params: {
                                                publisherId: "158892",
                                                adSlot: "5784587",
                                              },
                                            },
{
                                              bidder: "richaudience",
                                              params: {
                                                pid: "XgSBQhVo8q",
                                                supplyType: "site",
                                              },
                                            },
{
                                              bidder: "rtbhouse",
                                              params: {
                                                region: "prebid-eu",
                                                publisherId:
                                                  "eq7oNcAuPBmB2fDVrcVE",
                                                bidfloor: 0.1,
                                              },
                                            },
{
                                              bidder: "rubicon",
                                              params: {
                                                accountId: 19712,
                                                siteId: 492430,
                                                zoneId: 3272234,
                                              },
                                            },
{
                                              bidder: "smartadserver",
                                              params: {
                                                networkId: "4527",
                                                siteId: "601617",
                                                pageId: "1836485",
                                                formatId: "127405",
                                              },
                                            },
{
                                              bidder: "teads",
                                              params: {
                                                pageId: 204237,
                                                placementId: 220483,
                                              },
                                            },
                                            {
                                              bidder: "connectad",
                                              params: {
                                                networkId: 44,
                                                siteId: 23211976
                                              },
                                            },
                                            {
                                              bidder: "ogury",
                                              params: {
                                                adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                              },
                                              labelAny: ["desktop"],
                                            },
                                            {
                                              bidder: "ogury",
                                              params: {
                                                adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                              },
                                              labelAny: ["mobile"],
                                            },
                                          ],
                                        }))
                                      : "P12" === e.id && adWindowWidth < 1e3
                                        ? ((void 0),
                                          adUnitsBTF.push({
                                            code: "P12",
                                            mediaTypes: {
                                              banner: {
                                                sizeConfig: [
                                                  {
                                                    minViewPort: [1024, 0],
                                                    sizes: [
                                                      [200, 200],
                                                      [250, 250],
                                                      [300, 250],
                                                      [120, 600],
                                                      [160, 600],
                                                      [300, 600],
                                                    ],
                                                  },
                                                  {
                                                    minViewPort: [469, 0],
                                                    sizes: [
                                                      [200, 200],
                                                      [250, 250],
                                                      [300, 250],
                                                    ],
                                                  },
                                                  {
                                                    minViewPort: [0, 0],
                                                    sizes: [
                                                      [200, 200],
                                                      [250, 250],
                                                      [300, 250],
                                                      [336, 280],
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            bids: [
{
                                                bidder: "adf",
                                                params: {
                                                  mid: "1875307",
                                                  priceType: "net",
                                                },
                                              },
{
                                                bidder: "directmedia",
                                                params: {
                                                  mid: "1931537",
                                                  priceType: "net",
                                                },
                                              },
{
                                                bidder: "criteo",
                                                params: {
                                                  networkId: 9517,
                                                },
                                              },
{
                                                bidder: "eskimi",
                                                params: {
                                                  placementId: 1578,
                                                },
                                              },
{
                                                bidder: "ix",
                                                params: {
                                                  siteId: "1081310",
                                                },
                                              },
{
                                                bidder: "openx",
                                                params: {
                                                  delDomain:
                                                    "ringieraxelspr-d.openx.net",
                                                  unit: "560677821",
                                                },
                                              },
{
                                                bidder: "pubmatic",
                                                params: {
                                                  publisherId: "158892",
                                                  adSlot: "5784588",
                                                },
                                              },
{
                                                bidder: "richaudience",
                                                params: {
                                                  pid: "BctmaOCJMv",
                                                  supplyType: "site",
                                                },
                                              },
{
                                                bidder: "rtbhouse",
                                                params: {
                                                  region: "prebid-eu",
                                                  publisherId:
                                                    "eq7oNcAuPBmB2fDVrcVE",
                                                  bidfloor: 0.1,
                                                },
                                              },
{
                                                bidder: "rubicon",
                                                params: {
                                                  accountId: 19712,
                                                  siteId: 492430,
                                                  zoneId: 3272236,
                                                },
                                              },
{
                                                bidder: "smartadserver",
                                                params: {
                                                  networkId: "4527",
                                                  siteId: "601617",
                                                  pageId: "1836485",
                                                  formatId: "127406",
                                                },
                                              },
{
                                                bidder: "teads",
                                                params: {
                                                  pageId: 204237,
                                                  placementId: 220483,
                                                },
                                              },
                                              {
                                                bidder: "connectad",
                                                params: {
                                                  networkId: 44,
                                                  siteId: 23211976
                                                },
                                              },
                                              {
                                                bidder: "ogury",
                                                params: {
                                                  adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                },
                                                labelAny: ["desktop"],
                                              },
                                              {
                                                bidder: "ogury",
                                                params: {
                                                  adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                },
                                                labelAny: ["mobile"],
                                              },
                                            ],
                                          }))
                                        : "InFeed_1" === e.id &&
                                            1e3 < adWindowWidth
                                          ? ((void 0),
                                            adUnitsATF.push({
                                              code: "InFeed_1",
                                              mediaTypes: {
                                                banner: {
                                                  sizeConfig: [
                                                    {
                                                      minViewPort: [1300, 0],
                                                      sizes: [
                                                        [728, 90],
                                                        [200, 200],
                                                        [250, 250],
                                                        [300, 250],
                                                        [336, 280],
                                                        [750, 100],
                                                        [750, 200],
                                                      ],
                                                    },
                                                    {
                                                      minViewPort: [469, 0],
                                                      sizes: [
                                                        [468, 60],
                                                        [200, 200],
                                                        [250, 250],
                                                        [300, 250],
                                                        [336, 280],
                                                        [300, 50],
                                                        [320, 50],
                                                      ],
                                                    },
                                                    {
                                                      minViewPort: [0, 0],
                                                      sizes: [
                                                        [300, 50],
                                                        [320, 50],
                                                        [300, 100],
                                                        [320, 100],
                                                        [200, 200],
                                                        [250, 250],
                                                        [300, 250],
                                                        [336, 280],
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              bids: [
{
                                                  bidder: "adf",
                                                  params: {
                                                    mid: "1875348",
                                                    priceType: "net",
                                                  },
                                                },
{
                                                  bidder: "directmedia",
                                                  params: {
                                                    mid: "1931501",
                                                    priceType: "net",
                                                  },
                                                },
{
                                                  bidder: "criteo",
                                                  params: {
                                                    networkId: 9517,
                                                  },
                                                },
{
                                                  bidder: "eskimi",
                                                  params: {
                                                    placementId: 1578,
                                                  },
                                                },
{
                                                  bidder: "ix",
                                                  params: {
                                                    siteId: "1081316",
                                                  },
                                                },
{
                                                  bidder: "openx",
                                                  params: {
                                                    delDomain:
                                                      "ringieraxelspr-d.openx.net",
                                                    unit: "560677824",
                                                  },
                                                },
{
                                                  bidder: "pubmatic",
                                                  params: {
                                                    publisherId: "158892",
                                                    adSlot: "5784591",
                                                  },
                                                },
{
                                                  bidder: "richaudience",
                                                  params: {
                                                    pid: "eoJINIf0Al",
                                                    supplyType: "site",
                                                  },
                                                },
{
                                                  bidder: "rtbhouse",
                                                  params: {
                                                    region: "prebid-eu",
                                                    publisherId:
                                                      "eq7oNcAuPBmB2fDVrcVE",
                                                    bidfloor: 0.1,
                                                  },
                                                },
{
                                                  bidder: "rubicon",
                                                  params: {
                                                    accountId: 19712,
                                                    siteId: 492430,
                                                    zoneId: 3272242,
                                                  },
                                                },
{
                                                  bidder: "smartadserver",
                                                  params: {
                                                    networkId: "4527",
                                                    siteId: "601617",
                                                    pageId: "1836485",
                                                    formatId: "125167",
                                                  },
                                                },
{
                                                  bidder: "teads",
                                                  params: {
                                                    pageId: 204237,
                                                    placementId: 220483,
                                                  },
                                                },
                                                {
                                                  bidder: "connectad",
                                                  params: {
                                                    networkId: 44,
                                                    siteId: 23211976
                                                  },
                                                },
                                                {
                                                  bidder: "ogury",
                                                  params: {
                                                    adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                  },
                                                  labelAny: ["desktop"],
                                                },
                                              ],
                                            }))
                                          : "InFeed_2" === e.id &&
                                              1e3 < adWindowWidth
                                            ? ((void 0),
                                              adUnitsBTF.push({
                                                code: "InFeed_2",
                                                mediaTypes: {
                                                  banner: {
                                                    sizeConfig: [
                                                      {
                                                        minViewPort: [1300, 0],
                                                        sizes: [
                                                          [728, 90],
                                                          [200, 200],
                                                          [250, 250],
                                                          [300, 250],
                                                          [336, 280],
                                                          [750, 100],
                                                          [750, 200],
                                                        ],
                                                      },
                                                      {
                                                        minViewPort: [469, 0],
                                                        sizes: [
                                                          [468, 60],
                                                          [200, 200],
                                                          [250, 250],
                                                          [300, 250],
                                                          [336, 280],
                                                          [300, 50],
                                                          [320, 50],
                                                        ],
                                                      },
                                                      {
                                                        minViewPort: [0, 0],
                                                        sizes: [
                                                          [300, 50],
                                                          [320, 50],
                                                          [300, 100],
                                                          [320, 100],
                                                          [200, 200],
                                                          [250, 250],
                                                          [300, 250],
                                                          [336, 280],
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                },
                                                bids: [
{
                                                    bidder: "adf",
                                                    params: {
                                                      mid: "1875349",
                                                      priceType: "net",
                                                    },
                                                  },
{
                                                    bidder: "directmedia",
                                                    params: {
                                                      mid: "1931543",
                                                      priceType: "net",
                                                    },
                                                  },
{
                                                    bidder: "criteo",
                                                    params: {
                                                      networkId: 9517,
                                                    },
                                                  },
{
                                                    bidder: "eskimi",
                                                    params: {
                                                      placementId: 1578,
                                                    },
                                                  },
{
                                                    bidder: "ix",
                                                    params: {
                                                      siteId: "1081317",
                                                    },
                                                  },
{
                                                    bidder: "openx",
                                                    params: {
                                                      delDomain:
                                                        "ringieraxelspr-d.openx.net",
                                                      unit: "560677825",
                                                    },
                                                  },
{
                                                    bidder: "pubmatic",
                                                    params: {
                                                      publisherId: "158892",
                                                      adSlot: "5784592",
                                                    },
                                                  },
{
                                                    bidder: "richaudience",
                                                    params: {
                                                      pid: "Qs7itEjwbH",
                                                      supplyType: "site",
                                                    },
                                                  },
{
                                                    bidder: "rtbhouse",
                                                    params: {
                                                      region: "prebid-eu",
                                                      publisherId:
                                                        "eq7oNcAuPBmB2fDVrcVE",
                                                      bidfloor: 0.1,
                                                    },
                                                  },
{
                                                    bidder: "rubicon",
                                                    params: {
                                                      accountId: 19712,
                                                      siteId: 492430,
                                                      zoneId: 3272244,
                                                    },
                                                  },
{
                                                    bidder: "smartadserver",
                                                    params: {
                                                      networkId: "4527",
                                                      siteId: "601617",
                                                      pageId: "1836485",
                                                      formatId: "125168",
                                                    },
                                                  },
{
                                                    bidder: "teads",
                                                    params: {
                                                      pageId: 204237,
                                                      placementId: 220483,
                                                    },
                                                  },
                                                  {
                                                    bidder: "connectad",
                                                    params: {
                                                      networkId: 44,
                                                      siteId: 23211976
                                                    },
                                                  },
                                                  {
                                                    bidder: "ogury",
                                                    params: {
                                                      adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                    },
                                                    labelAny: ["desktop"],
                                                  },
                                                ],
                                              }))
                                            : "InFeed_3" === e.id &&
                                                1e3 < adWindowWidth
                                              ? ((void 0),
                                                adUnitsBTF.push({
                                                  code: "InFeed_3",
                                                  mediaTypes: {
                                                    banner: {
                                                      sizeConfig: [
                                                        {
                                                          minViewPort: [
                                                            1300, 0,
                                                          ],
                                                          sizes: [
                                                            [728, 90],
                                                            [200, 200],
                                                            [250, 250],
                                                            [300, 250],
                                                            [336, 280],
                                                            [750, 100],
                                                            [750, 200],
                                                          ],
                                                        },
                                                        {
                                                          minViewPort: [469, 0],
                                                          sizes: [
                                                            [468, 60],
                                                            [200, 200],
                                                            [250, 250],
                                                            [300, 250],
                                                            [336, 280],
                                                            [300, 50],
                                                            [320, 50],
                                                          ],
                                                        },
                                                        {
                                                          minViewPort: [0, 0],
                                                          sizes: [
                                                            [300, 50],
                                                            [320, 50],
                                                            [300, 100],
                                                            [320, 100],
                                                            [200, 200],
                                                            [250, 250],
                                                            [300, 250],
                                                            [336, 280],
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  bids: [
{
                                                      bidder: "adf",
                                                      params: {
                                                        mid: "1875350",
                                                        priceType: "net",
                                                      },
                                                    },
{
                                                      bidder: "directmedia",
                                                      params: {
                                                        mid: "1931544",
                                                        priceType: "net",
                                                      },
                                                    },
{
                                                      bidder: "criteo",
                                                      params: {
                                                        networkId: 9517,
                                                      },
                                                    },
{
                                                      bidder: "eskimi",
                                                      params: {
                                                        placementId: 1578,
                                                      },
                                                    },
{
                                                      bidder: "ix",
                                                      params: {
                                                        siteId: "1081318",
                                                      },
                                                    },
{
                                                      bidder: "openx",
                                                      params: {
                                                        delDomain:
                                                          "ringieraxelspr-d.openx.net",
                                                        unit: "560677826",
                                                      },
                                                    },
{
                                                      bidder: "pubmatic",
                                                      params: {
                                                        publisherId: "158892",
                                                        adSlot: "5784593",
                                                      },
                                                    },
{
                                                      bidder: "richaudience",
                                                      params: {
                                                        pid: "72MUP7mezL",
                                                        supplyType: "site",
                                                      },
                                                    },
{
                                                      bidder: "rtbhouse",
                                                      params: {
                                                        region: "prebid-eu",
                                                        publisherId:
                                                          "eq7oNcAuPBmB2fDVrcVE",
                                                        bidfloor: 0.1,
                                                      },
                                                    },
{
                                                      bidder: "rubicon",
                                                      params: {
                                                        accountId: 19712,
                                                        siteId: 492430,
                                                        zoneId: 3272246,
                                                      },
                                                    },
{
                                                      bidder: "smartadserver",
                                                      params: {
                                                        networkId: "4527",
                                                        siteId: "601617",
                                                        pageId: "1836485",
                                                        formatId: "125169",
                                                      },
                                                    },
{
                                                      bidder: "teads",
                                                      params: {
                                                        pageId: 204237,
                                                        placementId: 220483,
                                                      },
                                                    },
                                                    {
                                                      bidder: "connectad",
                                                      params: {
                                                        networkId: 44,
                                                        siteId: 23211976
                                                      },
                                                    },
                                                    {
                                                      bidder: "ogury",
                                                      params: {
                                                        adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                      },
                                                      labelAny: ["desktop"],
                                                    },
                                                  ],
                                                }))
                                              : "InFeed_4" === e.id &&
                                                  1e3 < adWindowWidth
                                                ? ((void 0),
                                                  adUnitsBTF.push({
                                                    code: "InFeed_4",
                                                    mediaTypes: {
                                                      banner: {
                                                        sizeConfig: [
                                                          {
                                                            minViewPort: [
                                                              1300, 0,
                                                            ],
                                                            sizes: [
                                                              [728, 90],
                                                              [200, 200],
                                                              [250, 250],
                                                              [300, 250],
                                                              [336, 280],
                                                              [750, 100],
                                                              [750, 200],
                                                            ],
                                                          },
                                                          {
                                                            minViewPort: [
                                                              469, 0,
                                                            ],
                                                            sizes: [
                                                              [468, 60],
                                                              [200, 200],
                                                              [250, 250],
                                                              [300, 250],
                                                              [336, 280],
                                                              [300, 50],
                                                              [320, 50],
                                                            ],
                                                          },
                                                          {
                                                            minViewPort: [0, 0],
                                                            sizes: [
                                                              [300, 50],
                                                              [320, 50],
                                                              [300, 100],
                                                              [320, 100],
                                                              [200, 200],
                                                              [250, 250],
                                                              [300, 250],
                                                              [336, 280],
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    bids: [
{
                                                        bidder: "adf",
                                                        params: {
                                                          mid: "1875351",
                                                          priceType: "net",
                                                        },
                                                      },
{
                                                        bidder: "directmedia",
                                                        params: {
                                                          mid: "1931545",
                                                          priceType: "net",
                                                        },
                                                      },
{
                                                        bidder: "criteo",
                                                        params: {
                                                          networkId: 9517,
                                                        },
                                                      },
{
                                                        bidder: "eskimi",
                                                        params: {
                                                          placementId: 1578,
                                                        },
                                                      },
{
                                                        bidder: "ix",
                                                        params: {
                                                          siteId: "1081319",
                                                        },
                                                      },
{
                                                        bidder: "openx",
                                                        params: {
                                                          delDomain:
                                                            "ringieraxelspr-d.openx.net",
                                                          unit: "560677827",
                                                        },
                                                      },
{
                                                        bidder: "pubmatic",
                                                        params: {
                                                          publisherId: "158892",
                                                          adSlot: "5784594",
                                                        },
                                                      },
{
                                                        bidder: "richaudience",
                                                        params: {
                                                          pid: "tLqFyur7bt",
                                                          supplyType: "site",
                                                        },
                                                      },
{
                                                        bidder: "rtbhouse",
                                                        params: {
                                                          region: "prebid-eu",
                                                          publisherId:
                                                            "eq7oNcAuPBmB2fDVrcVE",
                                                          bidfloor: 0.1,
                                                        },
                                                      },
{
                                                        bidder: "rubicon",
                                                        params: {
                                                          accountId: 19712,
                                                          siteId: 492430,
                                                          zoneId: 3272248,
                                                        },
                                                      },
{
                                                        bidder: "smartadserver",
                                                        params: {
                                                          networkId: "4527",
                                                          siteId: "601617",
                                                          pageId: "1836485",
                                                          formatId: "125170",
                                                        },
                                                      },
{
                                                        bidder: "teads",
                                                        params: {
                                                          pageId: 204237,
                                                          placementId: 220483,
                                                        },
                                                      },
                                                      {
                                                        bidder: "connectad",
                                                        params: {
                                                          networkId: 44,
                                                          siteId: 23211976
                                                        },
                                                      },
                                                      {
                                                        bidder: "ogury",
                                                        params: {
                                                          adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                        },
                                                        labelAny: ["desktop"],
                                                      },
                                                    ],
                                                  }))
                                                : "InFeed_5" === e.id &&
                                                    1e3 < adWindowWidth
                                                  ? ((void 0),
                                                    adUnitsBTF.push({
                                                      code: "InFeed_5",
                                                      mediaTypes: {
                                                        banner: {
                                                          sizeConfig: [
                                                            {
                                                              minViewPort: [
                                                                1300, 0,
                                                              ],
                                                              sizes: [
                                                                [728, 90],
                                                                [200, 200],
                                                                [250, 250],
                                                                [300, 250],
                                                                [336, 280],
                                                                [750, 100],
                                                                [750, 200],
                                                              ],
                                                            },
                                                            {
                                                              minViewPort: [
                                                                469, 0,
                                                              ],
                                                              sizes: [
                                                                [468, 60],
                                                                [200, 200],
                                                                [250, 250],
                                                                [300, 250],
                                                                [336, 280],
                                                                [300, 50],
                                                                [320, 50],
                                                              ],
                                                            },
                                                            {
                                                              minViewPort: [
                                                                0, 0,
                                                              ],
                                                              sizes: [
                                                                [300, 50],
                                                                [320, 50],
                                                                [300, 100],
                                                                [320, 100],
                                                                [200, 200],
                                                                [250, 250],
                                                                [300, 250],
                                                                [336, 280],
                                                              ],
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      bids: [
{
                                                          bidder: "adf",
                                                          params: {
                                                            mid: "1875352",
                                                            priceType: "net",
                                                          },
                                                        },
{
                                                          bidder: "directmedia",
                                                          params: {
                                                            mid: "1931546",
                                                            priceType: "net",
                                                          },
                                                        },
{
                                                          bidder: "criteo",
                                                          params: {
                                                            networkId: 9517,
                                                          },
                                                        },
{
                                                          bidder: "eskimi",
                                                          params: {
                                                            placementId: 1578,
                                                          },
                                                        },
{
                                                          bidder: "ix",
                                                          params: {
                                                            siteId: "1081320",
                                                          },
                                                        },
{
                                                          bidder: "openx",
                                                          params: {
                                                            delDomain:
                                                              "ringieraxelspr-d.openx.net",
                                                            unit: "560677828",
                                                          },
                                                        },
{
                                                          bidder: "pubmatic",
                                                          params: {
                                                            publisherId:
                                                              "158892",
                                                            adSlot: "5784595",
                                                          },
                                                        },
{
                                                          bidder:
                                                            "richaudience",
                                                          params: {
                                                            pid: "5TnVTwNioT",
                                                            supplyType: "site",
                                                          },
                                                        },
{
                                                          bidder: "rtbhouse",
                                                          params: {
                                                            region: "prebid-eu",
                                                            publisherId:
                                                              "eq7oNcAuPBmB2fDVrcVE",
                                                            bidfloor: 0.1,
                                                          },
                                                        },
{
                                                          bidder: "rubicon",
                                                          params: {
                                                            accountId: 19712,
                                                            siteId: 492430,
                                                            zoneId: 3272250,
                                                          },
                                                        },
{
                                                          bidder:
                                                            "smartadserver",
                                                          params: {
                                                            networkId: "4527",
                                                            siteId: "601617",
                                                            pageId: "1836485",
                                                            formatId: "125171",
                                                          },
                                                        },
{
                                                          bidder: "teads",
                                                          params: {
                                                            pageId: 204237,
                                                            placementId: 220483,
                                                          },
                                                        },
                                                        {
                                                          bidder: "connectad",
                                                          params: {
                                                            networkId: 44,
                                                            siteId: 23211976
                                                          },
                                                        },
                                                        {
                                                          bidder: "ogury",
                                                          params: {
                                                            adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                          },
                                                          labelAny: ["desktop"],
                                                        },
                                                      ],
                                                    }))
                                                  : "InText_1" === e.id
                                                    ? ((void 0),
                                                      adUnitsATF.push({
                                                        code: "InText_1",
                                                        mediaTypes: {
                                                          banner: {
                                                            sizeConfig: [
                                                              {
                                                                minViewPort: [
                                                                  1024, 0,
                                                                ],
                                                                sizes: [
                                                                  [200, 200],
                                                                  [250, 250],
                                                                  [300, 250],
                                                                  [336, 280],
                                                                  [580, 250],
                                                                  [580, 280],
                                                                ],
                                                              },
                                                              {
                                                                minViewPort: [
                                                                  469, 0,
                                                                ],
                                                                sizes: [
                                                                  [468, 60],
                                                                  [200, 200],
                                                                  [250, 250],
                                                                  [300, 250],
                                                                  [336, 280],
                                                                  [300, 50],
                                                                  [320, 50],
                                                                ],
                                                              },
                                                              {
                                                                minViewPort: [
                                                                  0, 0,
                                                                ],
                                                                sizes: [
                                                                  [300, 50],
                                                                  [320, 50],
                                                                  [300, 100],
                                                                  [320, 100],
                                                                  [200, 200],
                                                                  [250, 250],
                                                                  [300, 250],
                                                                  [336, 280],
                                                                ],
                                                              },
                                                            ],
                                                          },
                                                        },
                                                        bids: [
{
                                                            bidder: "adf",
                                                            params: {
                                                              mid: "1710633",
                                                              priceType: "net",
                                                            },
                                                          },
{
                                                            bidder:
                                                              "directmedia",
                                                            params: {
                                                              mid: "1931503",
                                                              priceType: "net",
                                                            },
                                                          },
{
                                                            bidder: "mediapool",
                                                            params: {
                                                              mid: "1984237",
                                                              priceType: "net",
                                                            },
                                                          },
{
                                                            bidder: "criteo",
                                                            params: {
                                                              networkId: 9517,
                                                            },
                                                          },
{
                                                            bidder: "eskimi",
                                                            params: {
                                                              placementId: 1578,
                                                            },
                                                          },
{
                                                            bidder: "ix",
                                                            params: {
                                                              siteId: "1081311",
                                                            },
                                                          },
{
                                                            bidder: "openx",
                                                            params: {
                                                              delDomain:
                                                                "ringieraxelspr-d.openx.net",
                                                              unit: "559525013",
                                                            },
                                                          },
{
                                                            bidder: "pubmatic",
                                                            params: {
                                                              publisherId:
                                                                "158892",
                                                              adSlot: "5228586",
                                                            },
                                                          },
{
                                                            bidder:
                                                              "richaudience",
                                                            params: {
                                                              pid: "OTX4lSmwVt",
                                                              supplyType:
                                                                "site",
                                                            },
                                                          },
{
                                                            bidder: "rtbhouse",
                                                            params: {
                                                              region:
                                                                "prebid-eu",
                                                              publisherId:
                                                                "eq7oNcAuPBmB2fDVrcVE",
                                                              bidfloor: 0.1,
                                                            },
                                                          },
{
                                                            bidder: "rubicon",
                                                            params: {
                                                              accountId: 19712,
                                                              siteId: 492430,
                                                              zoneId: 2919222,
                                                            },
                                                          },
{
                                                            bidder:
                                                              "smartadserver",
                                                            params: {
                                                              networkId: "4527",
                                                              siteId: "601617",
                                                              pageId: "1836485",
                                                              formatId:
                                                                "120627",
                                                            },
                                                          },
{
                                                            bidder: "teads",
                                                            params: {
                                                              pageId: 204236,
                                                              placementId: 220482,
                                                            },
                                                          },
                                                          {
                                                            bidder: "connectad",
                                                            params: {
                                                              networkId: 44,
                                                              siteId: 23211976
                                                            },
                                                          },
                                                          {
                                                            bidder: "ogury",
                                                            params: {
                                                              adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                            },
                                                            labelAny: ["desktop"],
                                                          },
                                                          {
                                                            bidder: "ogury",
                                                            params: {
                                                              adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                            },
                                                            labelAny: ["mobile"],
                                                          },
                                                        ],
                                                      }))
                                                    : "InText_2" === e.id
                                                      ? ((void 0),
                                                        adUnitsBTF.push({
                                                          code: "InText_2",
                                                          mediaTypes: {
                                                            banner: {
                                                              sizeConfig: [
                                                                {
                                                                  minViewPort: [
                                                                    1024, 0,
                                                                  ],
                                                                  sizes: [
                                                                    [200, 200],
                                                                    [250, 250],
                                                                    [300, 250],
                                                                    [336, 280],
                                                                    [580, 250],
                                                                    [580, 280],
                                                                  ],
                                                                },
                                                                {
                                                                  minViewPort: [
                                                                    469, 0,
                                                                  ],
                                                                  sizes: [
                                                                    [468, 60],
                                                                    [200, 200],
                                                                    [250, 250],
                                                                    [300, 250],
                                                                    [336, 280],
                                                                    [300, 50],
                                                                    [320, 50],
                                                                  ],
                                                                },
                                                                {
                                                                  minViewPort: [
                                                                    0, 0,
                                                                  ],
                                                                  sizes: [
                                                                    [300, 50],
                                                                    [320, 50],
                                                                    [300, 100],
                                                                    [320, 100],
                                                                    [200, 200],
                                                                    [250, 250],
                                                                    [300, 250],
                                                                    [336, 280],
                                                                  ],
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          bids: [
{
                                                              bidder: "adf",
                                                              params: {
                                                                mid: "1710634",
                                                                priceType:
                                                                  "net",
                                                              },
                                                            },
{
                                                              bidder:
                                                                "directmedia",
                                                              params: {
                                                                mid: "1931547",
                                                                priceType:
                                                                  "net",
                                                              },
                                                            },
{
                                                              bidder: "criteo",
                                                              params: {
                                                                networkId: 9517,
                                                              },
                                                            },
{
                                                              bidder: "eskimi",
                                                              params: {
                                                                placementId: 1578,
                                                              },
                                                            },
{
                                                              bidder: "ix",
                                                              params: {
                                                                siteId:
                                                                  "1081312",
                                                              },
                                                            },
{
                                                              bidder: "openx",
                                                              params: {
                                                                delDomain:
                                                                  "ringieraxelspr-d.openx.net",
                                                                unit: "559525014",
                                                              },
                                                            },
{
                                                              bidder:
                                                                "pubmatic",
                                                              params: {
                                                                publisherId:
                                                                  "158892",
                                                                adSlot:
                                                                  "5228587",
                                                              },
                                                            },
{
                                                              bidder:
                                                                "richaudience",
                                                              params: {
                                                                pid: "EZ9YP5WGlu",
                                                                supplyType:
                                                                  "site",
                                                              },
                                                            },
{
                                                              bidder:
                                                                "rtbhouse",
                                                              params: {
                                                                region:
                                                                  "prebid-eu",
                                                                publisherId:
                                                                  "eq7oNcAuPBmB2fDVrcVE",
                                                                bidfloor: 0.1,
                                                              },
                                                            },
{
                                                              bidder: "rubicon",
                                                              params: {
                                                                accountId: 19712,
                                                                siteId: 492430,
                                                                zoneId: 2919224,
                                                              },
                                                            },
{
                                                              bidder:
                                                                "smartadserver",
                                                              params: {
                                                                networkId:
                                                                  "4527",
                                                                siteId:
                                                                  "601617",
                                                                pageId:
                                                                  "1836485",
                                                                formatId:
                                                                  "120628",
                                                              },
                                                            },
{
                                                              bidder: "teads",
                                                              params: {
                                                                pageId: 204236,
                                                                placementId: 220482,
                                                              },
                                                            },
                                                            {
                                                              bidder: "connectad",
                                                              params: {
                                                                networkId: 44,
                                                                siteId: 23211976
                                                              },
                                                            },
                                                            {
                                                              bidder: "ogury",
                                                              params: {
                                                                adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                              },
                                                              labelAny: ["desktop"],
                                                            },
                                                            {
                                                              bidder: "ogury",
                                                              params: {
                                                                adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                              },
                                                              labelAny: ["mobile"],
                                                            },
                                                          ],
                                                        }))
                                                      : "InText_3" === e.id
                                                        ? ((void 0),
                                                          adUnitsBTF.push({
                                                            code: "InText_3",
                                                            mediaTypes: {
                                                              banner: {
                                                                sizeConfig: [
                                                                  {
                                                                    minViewPort:
                                                                      [1024, 0],
                                                                    sizes: [
                                                                      [
                                                                        200,
                                                                        200,
                                                                      ],
                                                                      [
                                                                        250,
                                                                        250,
                                                                      ],
                                                                      [
                                                                        300,
                                                                        250,
                                                                      ],
                                                                      [
                                                                        336,
                                                                        280,
                                                                      ],
                                                                      [
                                                                        580,
                                                                        250,
                                                                      ],
                                                                      [
                                                                        580,
                                                                        280,
                                                                      ],
                                                                    ],
                                                                  },
                                                                  {
                                                                    minViewPort:
                                                                      [469, 0],
                                                                    sizes: [
                                                                      [468, 60],
                                                                      [
                                                                        200,
                                                                        200,
                                                                      ],
                                                                      [
                                                                        250,
                                                                        250,
                                                                      ],
                                                                      [
                                                                        300,
                                                                        250,
                                                                      ],
                                                                      [
                                                                        336,
                                                                        280,
                                                                      ],
                                                                      [300, 50],
                                                                      [320, 50],
                                                                    ],
                                                                  },
                                                                  {
                                                                    minViewPort:
                                                                      [0, 0],
                                                                    sizes: [
                                                                      [300, 50],
                                                                      [320, 50],
                                                                      [
                                                                        300,
                                                                        100,
                                                                      ],
                                                                      [
                                                                        320,
                                                                        100,
                                                                      ],
                                                                      [
                                                                        200,
                                                                        200,
                                                                      ],
                                                                      [
                                                                        250,
                                                                        250,
                                                                      ],
                                                                      [
                                                                        300,
                                                                        250,
                                                                      ],
                                                                      [
                                                                        336,
                                                                        280,
                                                                      ],
                                                                    ],
                                                                  },
                                                                ],
                                                              },
                                                            },
                                                            bids: [
{
                                                                bidder: "adf",
                                                                params: {
                                                                  mid: "1710635",
                                                                  priceType:
                                                                    "net",
                                                                },
                                                              },
{
                                                                bidder:
                                                                  "directmedia",
                                                                params: {
                                                                  mid: "1931548",
                                                                  priceType:
                                                                    "net",
                                                                },
                                                              },
{
                                                                bidder:
                                                                  "criteo",
                                                                params: {
                                                                  networkId: 9517,
                                                                },
                                                              },
{
                                                                bidder:
                                                                  "eskimi",
                                                                params: {
                                                                  placementId: 1578,
                                                                },
                                                              },
{
                                                                bidder: "ix",
                                                                params: {
                                                                  siteId:
                                                                    "1081313",
                                                                },
                                                              },
{
                                                                bidder: "openx",
                                                                params: {
                                                                  delDomain:
                                                                    "ringieraxelspr-d.openx.net",
                                                                  unit: "559525015",
                                                                },
                                                              },
{
                                                                bidder:
                                                                  "pubmatic",
                                                                params: {
                                                                  publisherId:
                                                                    "158892",
                                                                  adSlot:
                                                                    "5228588",
                                                                },
                                                              },
{
                                                                bidder:
                                                                  "richaudience",
                                                                params: {
                                                                  pid: "3TMGc84Cxs",
                                                                  supplyType:
                                                                    "site",
                                                                },
                                                              },
{
                                                                bidder:
                                                                  "rtbhouse",
                                                                params: {
                                                                  region:
                                                                    "prebid-eu",
                                                                  publisherId:
                                                                    "eq7oNcAuPBmB2fDVrcVE",
                                                                  bidfloor: 0.1,
                                                                },
                                                              },
{
                                                                bidder:
                                                                  "rubicon",
                                                                params: {
                                                                  accountId: 19712,
                                                                  siteId: 492430,
                                                                  zoneId: 2919228,
                                                                },
                                                              },
{
                                                                bidder:
                                                                  "smartadserver",
                                                                params: {
                                                                  networkId:
                                                                    "4527",
                                                                  siteId:
                                                                    "601617",
                                                                  pageId:
                                                                    "1836485",
                                                                  formatId:
                                                                    "120629",
                                                                },
                                                              },
{
                                                                bidder: "teads",
                                                                params: {
                                                                  pageId: 204236,
                                                                  placementId: 220482,
                                                                },
                                                              },
                                                              {
                                                                bidder: "connectad",
                                                                params: {
                                                                  networkId: 44,
                                                                  siteId: 23211976
                                                                },
                                                              },
                                                              {
                                                                bidder: "ogury",
                                                                params: {
                                                                  adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                                },
                                                                labelAny: ["desktop"],
                                                              },
                                                              {
                                                                bidder: "ogury",
                                                                params: {
                                                                  adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                                },
                                                                labelAny: ["mobile"],
                                                              },
                                                            ],
                                                          }))
                                                        : "InText_4" === e.id
                                                          ? ((void 0),
                                                            adUnitsBTF.push({
                                                              code: "InText_4",
                                                              mediaTypes: {
                                                                banner: {
                                                                  sizeConfig: [
                                                                    {
                                                                      minViewPort:
                                                                        [
                                                                          1024,
                                                                          0,
                                                                        ],
                                                                      sizes: [
                                                                        [
                                                                          200,
                                                                          200,
                                                                        ],
                                                                        [
                                                                          250,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          336,
                                                                          280,
                                                                        ],
                                                                        [
                                                                          580,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          580,
                                                                          280,
                                                                        ],
                                                                      ],
                                                                    },
                                                                    {
                                                                      minViewPort:
                                                                        [
                                                                          469,
                                                                          0,
                                                                        ],
                                                                      sizes: [
                                                                        [
                                                                          468,
                                                                          60,
                                                                        ],
                                                                        [
                                                                          200,
                                                                          200,
                                                                        ],
                                                                        [
                                                                          250,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          336,
                                                                          280,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          50,
                                                                        ],
                                                                        [
                                                                          320,
                                                                          50,
                                                                        ],
                                                                      ],
                                                                    },
                                                                    {
                                                                      minViewPort:
                                                                        [0, 0],
                                                                      sizes: [
                                                                        [
                                                                          300,
                                                                          50,
                                                                        ],
                                                                        [
                                                                          320,
                                                                          50,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          100,
                                                                        ],
                                                                        [
                                                                          320,
                                                                          100,
                                                                        ],
                                                                        [
                                                                          200,
                                                                          200,
                                                                        ],
                                                                        [
                                                                          250,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          336,
                                                                          280,
                                                                        ],
                                                                      ],
                                                                    },
                                                                  ],
                                                                },
                                                              },
                                                              bids: [
{
                                                                  bidder: "adf",
                                                                  params: {
                                                                    mid: "1875308",
                                                                    priceType:
                                                                      "net",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "directmedia",
                                                                  params: {
                                                                    mid: "1931549",
                                                                    priceType:
                                                                      "net",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "criteo",
                                                                  params: {
                                                                    networkId: 9517,
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "eskimi",
                                                                  params: {
                                                                    placementId: 1578,
                                                                  },
                                                                },
{
                                                                  bidder: "ix",
                                                                  params: {
                                                                    siteId:
                                                                      "1081314",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "openx",
                                                                  params: {
                                                                    delDomain:
                                                                      "ringieraxelspr-d.openx.net",
                                                                    unit: "560677822",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "pubmatic",
                                                                  params: {
                                                                    publisherId:
                                                                      "158892",
                                                                    adSlot:
                                                                      "5784589",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "richaudience",
                                                                  params: {
                                                                    pid: "Fc171PHkDa",
                                                                    supplyType:
                                                                      "site",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "rtbhouse",
                                                                  params: {
                                                                    region:
                                                                      "prebid-eu",
                                                                    publisherId:
                                                                      "eq7oNcAuPBmB2fDVrcVE",
                                                                    bidfloor: 0.1,
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "rubicon",
                                                                  params: {
                                                                    accountId: 19712,
                                                                    siteId: 492430,
                                                                    zoneId: 3272238,
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "smartadserver",
                                                                  params: {
                                                                    networkId:
                                                                      "4527",
                                                                    siteId:
                                                                      "601617",
                                                                    pageId:
                                                                      "1836485",
                                                                    formatId:
                                                                      "124582",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "teads",
                                                                  params: {
                                                                    pageId: 204236,
                                                                    placementId: 220482,
                                                                  },
                                                                },
                                                                {
                                                                  bidder: "connectad",
                                                                  params: {
                                                                    networkId: 44,
                                                                    siteId: 23211976
                                                                  },
                                                                },
                                                                {
                                                                  bidder: "ogury",
                                                                  params: {
                                                                    adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                                  },
                                                                  labelAny: ["desktop"],
                                                                },
                                                                {
                                                                  bidder: "ogury",
                                                                  params: {
                                                                    adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                                  },
                                                                  labelAny: ["mobile"],
                                                                },
                                                              ],
                                                            }))
                                                          : "InText_5" ===
                                                              e.id &&
                                                            ((void 0),
                                                            adUnitsBTF.push({
                                                              code: "InText_5",
                                                              mediaTypes: {
                                                                banner: {
                                                                  sizeConfig: [
                                                                    {
                                                                      minViewPort:
                                                                        [
                                                                          1024,
                                                                          0,
                                                                        ],
                                                                      sizes: [
                                                                        [
                                                                          200,
                                                                          200,
                                                                        ],
                                                                        [
                                                                          250,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          336,
                                                                          280,
                                                                        ],
                                                                        [
                                                                          580,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          580,
                                                                          280,
                                                                        ],
                                                                      ],
                                                                    },
                                                                    {
                                                                      minViewPort:
                                                                        [
                                                                          469,
                                                                          0,
                                                                        ],
                                                                      sizes: [
                                                                        [
                                                                          468,
                                                                          60,
                                                                        ],
                                                                        [
                                                                          200,
                                                                          200,
                                                                        ],
                                                                        [
                                                                          250,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          336,
                                                                          280,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          50,
                                                                        ],
                                                                        [
                                                                          320,
                                                                          50,
                                                                        ],
                                                                      ],
                                                                    },
                                                                    {
                                                                      minViewPort:
                                                                        [0, 0],
                                                                      sizes: [
                                                                        [
                                                                          300,
                                                                          50,
                                                                        ],
                                                                        [
                                                                          320,
                                                                          50,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          100,
                                                                        ],
                                                                        [
                                                                          320,
                                                                          100,
                                                                        ],
                                                                        [
                                                                          200,
                                                                          200,
                                                                        ],
                                                                        [
                                                                          250,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          300,
                                                                          250,
                                                                        ],
                                                                        [
                                                                          336,
                                                                          280,
                                                                        ],
                                                                      ],
                                                                    },
                                                                  ],
                                                                },
                                                              },
                                                              bids: [
{
                                                                  bidder: "adf",
                                                                  params: {
                                                                    mid: "1875309",
                                                                    priceType:
                                                                      "net",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "directmedia",
                                                                  params: {
                                                                    mid: "1931550",
                                                                    priceType:
                                                                      "net",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "criteo",
                                                                  params: {
                                                                    networkId: 9517,
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "eskimi",
                                                                  params: {
                                                                    placementId: 1578,
                                                                  },
                                                                },
{
                                                                  bidder: "ix",
                                                                  params: {
                                                                    siteId:
                                                                      "1081315",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "openx",
                                                                  params: {
                                                                    delDomain:
                                                                      "ringieraxelspr-d.openx.net",
                                                                    unit: "560677823",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "pubmatic",
                                                                  params: {
                                                                    publisherId:
                                                                      "158892",
                                                                    adSlot:
                                                                      "5784590",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "richaudience",
                                                                  params: {
                                                                    pid: "GeglIh1zl5",
                                                                    supplyType:
                                                                      "site",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "rtbhouse",
                                                                  params: {
                                                                    region:
                                                                      "prebid-eu",
                                                                    publisherId:
                                                                      "eq7oNcAuPBmB2fDVrcVE",
                                                                    bidfloor: 0.1,
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "rubicon",
                                                                  params: {
                                                                    accountId: 19712,
                                                                    siteId: 492430,
                                                                    zoneId: 3272240,
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "smartadserver",
                                                                  params: {
                                                                    networkId:
                                                                      "4527",
                                                                    siteId:
                                                                      "601617",
                                                                    pageId:
                                                                      "1836485",
                                                                    formatId:
                                                                      "124583",
                                                                  },
                                                                },
{
                                                                  bidder:
                                                                    "teads",
                                                                  params: {
                                                                    pageId: 204236,
                                                                    placementId: 220482,
                                                                  },
                                                                },
                                                                {
                                                                  bidder: "connectad",
                                                                  params: {
                                                                    networkId: 44,
                                                                    siteId: 23211976
                                                                  },
                                                                },
                                                                {
                                                                  bidder: "ogury",
                                                                  params: {
                                                                    adUnitId: "wd-hb-stdb-alo-ringi-hrj8bxknplviesw",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                                  },
                                                                  labelAny: ["desktop"],
                                                                },
                                                                {
                                                                  bidder: "ogury",
                                                                  params: {
                                                                    adUnitId: "wm-hb-stdb-alo-ringi-idztai00jd04ilv",
                  assetKey: "OGY-7EA4C1ECA90C",
                                                                  },
                                                                  labelAny: ["mobile"],
                                                                },
                                                              ],
                                                            }));
    });
  }

  // 13102026 PREBID-FIRST BOOT, part 1: ad units without GPT.
  buildPrebidAdUnits();

  // 13102026 PREBID-FIRST BOOT, part 2: the ad-unit arrays were built by
  // buildPrebidAdUnits() above, so Prebid no longer waits for gpt.js.
  pbjs.que.push(function () {
      (pbjs.aliasBidder("adf", "directmedia", {
        gvlid: 50,
      }),
        pbjs.aliasBidder("adf", "mediapool", {
          gvlid: 50,
        }),
        pbjs.setConfig({
          sizeConfig: [
            {
              mediaQuery: "(min-width: 1024px)",
              labels: ["desktop"],
            },
            {
              mediaQuery: "(max-width: 1023px)",
              labels: ["mobile"],
            },
          ],
          priceGranularity: "high",
          enableSendAllBids: !1,
          targetingControls: {
            alwaysIncludeDeals: !0,
          },
          currency: {
            adServerCurrency: "EUR",
            conversionRateFile:
              "https://cdn.jsdelivr.net/gh/prebid/currency-file@1/latest.json",
          },
          userSync: {
            syncEnabled: !0,
            syncsPerBidder: 5,
            syncDelay: 3e3,
            userIds: [
              {
                name: "sharedId",
                storage: {
                  type: "cookie",
                  name: "_sharedid",
                  expires: 365,
                },
              },
              {
                name: "id5Id",
                params: {
                  partner: 1355,
                  externalModuleUrl:
                    "https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js",
                },
                storage: {
                  type: "html5",
                  name: "id5id",
                  expires: 90,
                  refreshInSeconds: 28800,
                },
              },
              {
                name: "teadsId",
                params: {
                  pubId: 26849,
                },
              },
              {
                name: "criteo",
              },
              {
                name: "lotamePanoramaId",
              },
            ],
            auctionDelay: 50,
            aliasSyncEnabled: !0,
            filterSettings: {
              all: {
                bidders: "*",
                filter: "include",
              },
            },
          },
          enableTIDs: !0,
          consentManagement: {
            gdpr: {
              cmpApi: "iab",
              timeout: 8e3,
              defaultGdprScope: !0,
            },
          },
          schain: {
            config: {
              ver: "1.0",
              complete: 1,
              nodes: [
                {
                  asi: "ringier.rs",
                  sid: "20221205191911",
                  hp: 1,
                },
              ],
            },
          },
        }),
        (pbjs.bidderSettings = {
          standard: {
            storageAllowed: !0,
          },
        }),
        pbjs.setBidderConfig({
          bidders: ["directmedia"],
          config: {
            schain: {
              config: {
                ver: "1.0",
                complete: 1,
                nodes: [
                  {
                    asi: "directmedia.biz",
                    sid: "1053",
                    hp: 1,
                  },
                ],
              },
            },
          },
        }),
        pbjs.addAdUnits(adUnitsATF),
        pbjs.requestBids({
          labels: getCurrentPrebidLabels(),
          adUnitCodes: adUnitsATF.map(function (adUnit) {
            return adUnit.code;
          }),
          bidsBackHandler: initAdserver,
          timeout: PREBID_TIMEOUT,
        }));
  });

  pbjs.que.push(function () {
    pbjs.addAdUnits(adUnitsBTF);
  });

  // GPT slots (the slot loop's GPT copy), page targeting, services, and the
  // safety timer that sends GPT without bids when the auction is slow.
  googletag.cmd.push(function () {
    var d = googletag
        .sizeMapping()
        .addSize(
          [1600, 0],
          [
            [728, 90],
            [970, 90],
            [980, 90],
            [1e3, 100],
            [750, 100],
            [750, 200],
          ],
        )
        .addSize(
          [1024, 0],
          [
            [728, 90],
            [750, 100],
          ],
        )
        .addSize(
          [469, 0],
          [
            [468, 60],
            [300, 50],
            [320, 50],
          ],
        )
        .addSize(
          [0, 0],
          [
            [300, 50],
            [320, 50],
            [300, 100],
            [320, 100],
          ],
        )
        .build(),
      i = googletag
        .sizeMapping()
        .addSize(
          [1300, 0],
          [
            [728, 90],
            [970, 66],
            [950, 90],
            [970, 90],
            [980, 90],
            [1e3, 100],
            [750, 100],
            [750, 200],
            [980, 120],
            [930, 180],
            [970, 250],
            [980, 240],
            [980, 250],
            [990, 250],
            [1060, 250],
            [1200, 250],
          ],
        )
        .addSize(
          [1024, 0],
          [
            [728, 90],
            [750, 100],
            [750, 200],
          ],
        )
        .addSize(
          [469, 0],
          [
            [468, 60],
            [300, 50],
            [320, 50],
          ],
        )
        .addSize(
          [0, 0],
          [
            [300, 50],
            [300, 75],
            [320, 80],
            [320, 50],
            [300, 100],
            [320, 100],
          ],
        )
        .build(),
      a = googletag
        .sizeMapping()
        .addSize(
          [1200, 0],
          [
            [2, 1],
            [120, 600],
            [160, 600],
          ],
        )
        .addSize([0, 0], [])
        .build(),
      r = googletag
        .sizeMapping()
        .addSize(
          [1024, 0],
          [
            [200, 200],
            [250, 250],
            [300, 250],
            [120, 600],
            [160, 600],
            [300, 600],
          ],
        )
        .addSize(
          [469, 0],
          [
            [200, 200],
            [250, 250],
            [300, 250],
          ],
        )
        .addSize(
          [0, 0],
          [
            [200, 200],
            [250, 250],
            [300, 250],
            [336, 280],
            [300, 50],
            [320, 50],
            [300, 100],
            [320, 100],
          ],
        )
        .build(),
      s = googletag
        .sizeMapping()
        .addSize(
          [1024, 0],
          [
            [200, 200],
            [250, 250],
            [300, 250],
            [120, 600],
            [160, 600],
            [300, 600],
          ],
        )
        .addSize(
          [469, 0],
          [
            [200, 200],
            [250, 250],
            [300, 250],
          ],
        )
        .addSize(
          [0, 0],
          [
            [200, 200],
            [250, 250],
            [300, 250],
            [336, 280],
          ],
        )
        .build(),
      t = googletag
        .sizeMapping()
        .addSize(
          [1024, 0],
          [
            [750, 100],
            [750, 200],
            [580, 250],
            [750, 250],
            [200, 200],
            [250, 250],
            [300, 250],
            [320, 250],
            [320, 240],
            [930, 250],
            "fluid",
          ],
        )
        .addSize(
          [469, 0],
          [
            [300, 50],
            [320, 50],
            [468, 60],
            [200, 200],
            [250, 250],
            [300, 250],
            [320, 250],
            [320, 240],
            [336, 280],
            "fluid",
          ],
        )
        .addSize(
          [0, 0],
          [
            [300, 50],
            [300, 75],
            [320, 80],
            [320, 50],
            [300, 100],
            [320, 100],
            [200, 200],
            [250, 250],
            [300, 250],
            [320, 250],
            [320, 240],
            [336, 280],
            "fluid",
          ],
        )
        .build(),
      n = googletag
        .sizeMapping()
        .addSize(
          [1024, 0],
          [
            [580, 280],
            [200, 200],
            [250, 250],
            [300, 250],
            [320, 250],
            [320, 240],
            [336, 280],
            "fluid",
          ],
        )
        .addSize(
          [469, 0],
          [
            [300, 50],
            [320, 50],
            [468, 60],
            [200, 200],
            [250, 250],
            [300, 250],
            [320, 250],
            [320, 240],
            [336, 280],
            "fluid",
          ],
        )
        .addSize(
          [0, 0],
          [
            [300, 50],
            [300, 75],
            [320, 80],
            [320, 50],
            [300, 100],
            [320, 100],
            [200, 200],
            [250, 250],
            [300, 250],
            [320, 250],
            [320, 240],
            [336, 280],
            "fluid",
          ],
        )
        .build();
    (o.forEach(function (e) {
      "Adhesion" === e.id
        ? ((Adhesion = googletag
            .defineSlot(
              adUnitPath + "Sticky",
              [
                [728, 90],
                [970, 90],
                [320, 50],
              ],
              "Adhesion",
            )
            .defineSizeMapping(d)
            .setTargeting("position", "Adhesion")
            .setTargeting("refresh_count", "0")
            .setTargeting("refresh_bucket", "initial")
            .addService(googletag.pubads())),
          void 0)
        : "Billboard" === e.id
          ? ((Billboard = googletag
              .defineSlot(adUnitPath + "Billboard", [[970, 250]], "Billboard")
              .defineSizeMapping(i)
              .setTargeting("position", "Billboard")
              .setTargeting("refresh_count", "0")
              .setTargeting("refresh_bucket", "initial")
              .addService(googletag.pubads())),
            void 0)
          : "Billboard_2" === e.id
            ? ((Billboard_2 = googletag
                .defineSlot(
                  adUnitPath + "Billboard_2",
                  [[970, 250]],
                  "Billboard_2",
                )
                .defineSizeMapping(i)
                .setTargeting("position", "Billboard_2")
                .setTargeting("refresh_count", "0")
                .setTargeting("refresh_bucket", "initial")
                .addService(googletag.pubads())),
              void 0)
            : "Branding_Left" === e.id && 1200 < adWindowWidth
              ? ((Branding_Left = googletag
                  .defineSlot(
                    adUnitPath + "Branding_Left",
                    [[480, 1080]],
                    "Branding_Left",
                  )
                  .defineSizeMapping(a)
                  .setTargeting("position", "Branding_Left")
                  .setTargeting("refresh_count", "0")
                  .setTargeting("refresh_bucket", "initial")
                  .addService(googletag.pubads())),
                void 0)
              : "Branding_Right" === e.id && 1200 < adWindowWidth
                ? ((Branding_Right = googletag
                    .defineSlot(
                      adUnitPath + "Branding_Right",
                      [[480, 1080]],
                      "Branding_Right",
                    )
                    .defineSizeMapping(a)
                    .setTargeting("position", "Branding_Right")
                    .setTargeting("refresh_count", "0")
                    .setTargeting("refresh_bucket", "initial")
                    .addService(googletag.pubads())),
                  void 0)
                : "P1" === e.id
                  ? ((P1 = googletag
                      .defineSlot(adUnitPath + "P1", [[300, 250]], "P1")
                      .defineSizeMapping(r)
                      .setTargeting("position", "P1")
                      .setTargeting("refresh_count", "0")
                      .setTargeting("refresh_bucket", "initial")
                      .addService(googletag.pubads())),
                    void 0)
                  : "P2" === e.id
                    ? ((P2 = googletag
                        .defineSlot(adUnitPath + "P2", [[300, 250]], "P2")
                        .defineSizeMapping(r)
                        .setTargeting("position", "P2")
                        .setTargeting("refresh_count", "0")
                        .setTargeting("refresh_bucket", "initial")
                        .addService(googletag.pubads())),
                      void 0)
                    : "P3" === e.id
                      ? ((P3 = googletag
                          .defineSlot(adUnitPath + "P3", [[300, 250]], "P3")
                          .defineSizeMapping(r)
                          .setTargeting("position", "P3")
                          .setTargeting("refresh_count", "0")
                          .setTargeting("refresh_bucket", "initial")
                          .addService(googletag.pubads())),
                        void 0)
                      : "P4" === e.id
                        ? ((P4 = googletag
                            .defineSlot(adUnitPath + "P4", [[300, 250]], "P4")
                            .defineSizeMapping(s)
                            .setTargeting("position", "P4")
                            .setTargeting("refresh_count", "0")
                            .setTargeting("refresh_bucket", "initial")
                            .addService(googletag.pubads())),
                          void 0)
                        : "P5" === e.id
                          ? ((P5 = googletag
                              .defineSlot(adUnitPath + "P5", [[300, 250]], "P5")
                              .defineSizeMapping(s)
                              .setTargeting("position", "P5")
                              .setTargeting("refresh_count", "0")
                              .setTargeting("refresh_bucket", "initial")
                              .addService(googletag.pubads())),
                            void 0)
                          : "P6" === e.id
                            ? ((P6 = googletag
                                .defineSlot(
                                  adUnitPath + "P6",
                                  [[300, 250]],
                                  "P6",
                                )
                                .defineSizeMapping(s)
                                .setTargeting("position", "P6")
                                .setTargeting("refresh_count", "0")
                                .setTargeting("refresh_bucket", "initial")
                                .addService(googletag.pubads())),
                              void 0)
                            : "P7" === e.id
                              ? ((P7 = googletag
                                  .defineSlot(
                                    adUnitPath + "P7",
                                    [[300, 250]],
                                    "P7",
                                  )
                                  .defineSizeMapping(s)
                                  .setTargeting("position", "P7")
                                  .setTargeting("refresh_count", "0")
                                  .setTargeting("refresh_bucket", "initial")
                                  .addService(googletag.pubads())),
                                void 0)
                              : "P8" === e.id && adWindowWidth < 1e3
                                ? ((P8 = googletag
                                    .defineSlot(
                                      adUnitPath + "P8",
                                      [[300, 250]],
                                      "P8",
                                    )
                                    .defineSizeMapping(s)
                                    .setTargeting("position", "P8")
                                    .setTargeting("refresh_count", "0")
                                    .setTargeting("refresh_bucket", "initial")
                                    .addService(googletag.pubads())),
                                  void 0)
                                : "P9" === e.id && adWindowWidth < 1e3
                                  ? ((P9 = googletag
                                      .defineSlot(
                                        adUnitPath + "P9",
                                        [[300, 250]],
                                        "P9",
                                      )
                                      .defineSizeMapping(s)
                                      .setTargeting("position", "P9")
                                      .setTargeting("refresh_count", "0")
                                      .setTargeting("refresh_bucket", "initial")
                                      .addService(googletag.pubads())),
                                    void 0)
                                  : "P10" === e.id && adWindowWidth < 1e3
                                    ? ((P10 = googletag
                                        .defineSlot(
                                          adUnitPath + "P10",
                                          [[300, 250]],
                                          "P10",
                                        )
                                        .defineSizeMapping(s)
                                        .setTargeting("position", "P10")
                                        .setTargeting("refresh_count", "0")
                                        .setTargeting(
                                          "refresh_bucket",
                                          "initial",
                                        )
                                        .addService(googletag.pubads())),
                                      void 0)
                                    : "P11" === e.id && adWindowWidth < 1e3
                                      ? ((P11 = googletag
                                          .defineSlot(
                                            adUnitPath + "P11",
                                            [[300, 250]],
                                            "P11",
                                          )
                                          .defineSizeMapping(s)
                                          .setTargeting("position", "P11")
                                          .setTargeting("refresh_count", "0")
                                          .setTargeting(
                                            "refresh_bucket",
                                            "initial",
                                          )
                                          .addService(googletag.pubads())),
                                        void 0)
                                      : "P12" === e.id && adWindowWidth < 1e3
                                        ? ((P12 = googletag
                                            .defineSlot(
                                              adUnitPath + "P12",
                                              [[300, 250]],
                                              "P12",
                                            )
                                            .defineSizeMapping(s)
                                            .setTargeting("position", "P12")
                                            .setTargeting("refresh_count", "0")
                                            .setTargeting(
                                              "refresh_bucket",
                                              "initial",
                                            )
                                            .addService(googletag.pubads())),
                                          void 0)
                                        : "InFeed_1" === e.id &&
                                            1e3 < adWindowWidth
                                          ? ((InFeed_1 = googletag
                                              .defineSlot(
                                                adUnitPath + "InFeed_1",
                                                [[300, 250]],
                                                "InFeed_1",
                                              )
                                              .defineSizeMapping(t)
                                              .setTargeting(
                                                "position",
                                                "InFeed_1",
                                              )
                                              .setTargeting(
                                                "refresh_count",
                                                "0",
                                              )
                                              .setTargeting(
                                                "refresh_bucket",
                                                "initial",
                                              )
                                              .addService(googletag.pubads())),
                                            void 0)
                                          : "InFeed_2" === e.id &&
                                              1e3 < adWindowWidth
                                            ? ((InFeed_2 = googletag
                                                .defineSlot(
                                                  adUnitPath + "InFeed_2",
                                                  [[300, 250]],
                                                  "InFeed_2",
                                                )
                                                .defineSizeMapping(t)
                                                .setTargeting(
                                                  "position",
                                                  "InFeed_2",
                                                )
                                                .setTargeting(
                                                  "refresh_count",
                                                  "0",
                                                )
                                                .setTargeting(
                                                  "refresh_bucket",
                                                  "initial",
                                                )
                                                .addService(
                                                  googletag.pubads(),
                                                )),
                                              void 0)
                                            : "InFeed_3" === e.id &&
                                                1e3 < adWindowWidth
                                              ? ((InFeed_3 = googletag
                                                  .defineSlot(
                                                    adUnitPath + "InFeed_3",
                                                    [[300, 250]],
                                                    "InFeed_3",
                                                  )
                                                  .defineSizeMapping(t)
                                                  .setTargeting(
                                                    "position",
                                                    "InFeed_3",
                                                  )
                                                  .setTargeting(
                                                    "refresh_count",
                                                    "0",
                                                  )
                                                  .setTargeting(
                                                    "refresh_bucket",
                                                    "initial",
                                                  )
                                                  .addService(
                                                    googletag.pubads(),
                                                  )),
                                                void 0)
                                              : "InFeed_4" === e.id &&
                                                  1e3 < adWindowWidth
                                                ? ((InFeed_4 = googletag
                                                    .defineSlot(
                                                      adUnitPath + "InFeed_4",
                                                      [[300, 250]],
                                                      "InFeed_4",
                                                    )
                                                    .defineSizeMapping(t)
                                                    .setTargeting(
                                                      "position",
                                                      "InFeed_4",
                                                    )
                                                    .setTargeting(
                                                      "refresh_count",
                                                      "0",
                                                    )
                                                    .setTargeting(
                                                      "refresh_bucket",
                                                      "initial",
                                                    )
                                                    .addService(
                                                      googletag.pubads(),
                                                    )),
                                                  void 0)
                                                : "InFeed_5" === e.id &&
                                                    1e3 < adWindowWidth
                                                  ? ((InFeed_5 = googletag
                                                      .defineSlot(
                                                        adUnitPath + "InFeed_5",
                                                        [[300, 250]],
                                                        "InFeed_5",
                                                      )
                                                      .defineSizeMapping(t)
                                                      .setTargeting(
                                                        "position",
                                                        "InFeed_5",
                                                      )
                                                      .setTargeting(
                                                        "refresh_count",
                                                        "0",
                                                      )
                                                      .setTargeting(
                                                        "refresh_bucket",
                                                        "initial",
                                                      )
                                                      .addService(
                                                        googletag.pubads(),
                                                      )),
                                                    void 0)
                                                  : "InText_1" === e.id
                                                    ? ((InText_1 = googletag
                                                        .defineSlot(
                                                          adUnitPath +
                                                            "InText_1",
                                                          [[300, 250]],
                                                          "InText_1",
                                                        )
                                                        .defineSizeMapping(n)
                                                        .setTargeting(
                                                          "position",
                                                          "InText_1",
                                                        )
                                                        .setTargeting(
                                                          "refresh_count",
                                                          "0",
                                                        )
                                                        .setTargeting(
                                                          "refresh_bucket",
                                                          "initial",
                                                        )
                                                        .addService(
                                                          googletag.pubads(),
                                                        )),
                                                      void 0)
                                                    : "InText_2" === e.id
                                                      ? ((InText_2 = googletag
                                                          .defineSlot(
                                                            adUnitPath +
                                                              "InText_2",
                                                            [[300, 250]],
                                                            "InText_2",
                                                          )
                                                          .defineSizeMapping(n)
                                                          .setTargeting(
                                                            "position",
                                                            "InText_2",
                                                          )
                                                          .setTargeting(
                                                            "refresh_count",
                                                            "0",
                                                          )
                                                          .setTargeting(
                                                            "refresh_bucket",
                                                            "initial",
                                                          )
                                                          .addService(
                                                            googletag.pubads(),
                                                          )),
                                                        void 0)
                                                      : "InText_3" === e.id
                                                        ? ((InText_3 = googletag
                                                            .defineSlot(
                                                              adUnitPath +
                                                                "InText_3",
                                                              [[300, 250]],
                                                              "InText_3",
                                                            )
                                                            .defineSizeMapping(
                                                              n,
                                                            )
                                                            .setTargeting(
                                                              "position",
                                                              "InText_3",
                                                            )
                                                            .setTargeting(
                                                              "refresh_count",
                                                              "0",
                                                            )
                                                            .setTargeting(
                                                              "refresh_bucket",
                                                              "initial",
                                                            )
                                                            .addService(
                                                              googletag.pubads(),
                                                            )),
                                                          void 0)
                                                        : "InText_4" === e.id
                                                          ? ((InText_4 =
                                                              googletag
                                                                .defineSlot(
                                                                  adUnitPath +
                                                                    "InText_4",
                                                                  [[300, 250]],
                                                                  "InText_4",
                                                                )
                                                                .defineSizeMapping(
                                                                  n,
                                                                )
                                                                .setTargeting(
                                                                  "position",
                                                                  "InText_4",
                                                                )
                                                                .setTargeting(
                                                                  "refresh_count",
                                                                  "0",
                                                                )
                                                                .setTargeting(
                                                                  "refresh_bucket",
                                                                  "initial",
                                                                )
                                                                .addService(
                                                                  googletag.pubads(),
                                                                )),
                                                            void 0)
                                                          : "InText_5" ===
                                                              e.id &&
                                                            ((InText_5 =
                                                              googletag
                                                                .defineSlot(
                                                                  adUnitPath +
                                                                    "InText_5",
                                                                  [[300, 250]],
                                                                  "InText_5",
                                                                )
                                                                .defineSizeMapping(
                                                                  n,
                                                                )
                                                                .setTargeting(
                                                                  "position",
                                                                  "InText_5",
                                                                )
                                                                .setTargeting(
                                                                  "refresh_count",
                                                                  "0",
                                                                )
                                                                .setTargeting(
                                                                  "refresh_bucket",
                                                                  "initial",
                                                                )
                                                                .addService(
                                                                  googletag.pubads(),
                                                                )),
                                                            void 0);
    }),
      googletag.pubads().addEventListener("slotRenderEnded", function (e) {
        var d = e.slot.getAdUnitPath(),
          i = document.getElementById("adhesion_background");
        if (d === adUnitPath + "Sticky" && !0 === e.isEmpty) {
          let e = document.getElementById("Adhesion");
          e.style.display = "none";
        } else if (d === adUnitPath + "Sticky" && null === i) {
          let d = document.getElementById("Adhesion");
          ((d.style.position = "fixed"),
            (d.style.zIndex = "999999"),
            (d.style.width = "100%"),
            (d.style.height = ""),
            (d.style.bottom = "0px"),
            (d.style.textAlign = "center"),
            (d.style.padding = "10px 0px 0px"),
            (d.style.borderTop = "1px #CCC solid"));
          let e = document.createElement("div");
          (e.setAttribute("ID", "adhesion_background"),
            (e.style.backgroundColor = "#FFF"),
            (e.style.opacity = 1024 < adWindowWidth ? "70%" : "100%"),
            (e.style.position = "absolute"),
            (e.style.height = "100%"),
            (e.style.width = "100%"),
            (e.style.top = "0"),
            (e.style.left = "0"),
            (e.style.zIndex = "-1"),
            d.appendChild(e));
          let i = document.createElement("div");
          (i.setAttribute("ID", "close_adhesion"),
            (i.style.position = "absolute"),
            (i.style.top = "-29px"),
            (i.style.right = "0px"),
            (i.style.cursor = "pointer"),
            (i.style.padding = "8px"),
            (i.style.border = "1px solid #CCC"),
            (i.style.background = "#FFF"),
            (i.style.borderBottom = "1px solid #FFF"),
            (i.style.borderTopLeftRadius = "10px"));
          let a = document.createElementNS("http://www.w3.org/2000/svg", "svg"),
            r = document.createElementNS("http://www.w3.org/2000/svg", "path");
          (a.setAttribute("display", "block"),
            a.setAttribute("fill", "#000"),
            a.setAttribute("width", "12px"),
            a.setAttribute("height", "12px"),
            a.setAttribute("viewBox", "0 0 8 8"),
            r.setAttribute(
              "d",
              "M1.41 0l-1.41 1.41.72.72 1.78 1.81-1.78 1.78-.72.69 1.41 1.44.72-.72 1.81-1.81 1.78 1.81.69.72 1.44-1.44-.72-.69-1.81-1.78 1.81-1.81.72-.72-1.44-1.41-.69.72-1.78 1.78-1.81-1.78-.72-.72z",
            ),
            a.appendChild(r),
            i.appendChild(a),
            d.appendChild(i),
            document.getElementById("close_adhesion").addEventListener(
              "click",
              function (e) {
                (e.preventDefault(), d.parentNode.removeChild(d));
              },
              !1,
            ));
        }
      }),
      applyPageLevelTargeting());
    (googletag.pubads().disableInitialLoad(),
      googletag.pubads().enableSingleRequest(),
      googletag.enableServices(),
      googletag
        .pubads()
        .getSlots()
        .forEach(function (e) {
          googletag.display(e.getSlotElementId());
        }));

    // If Prebid or optional ID/consent work is delayed, GPT still gets the first request.
    setTimeout(initAdserver, PREBID_TIMEOUT + 300);
  });


  googletag.cmd.push(function () {
    var i = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          var lazySlotCode = entry.target.id;
          i.unobserve(entry.target);

          // 13102026: never auction a slot this wrapper does not load lazily.
          if (!isLazyLoadedSlotCode(lazySlotCode)) {
            adsDebugLog("lazyAd element ignored, not a lazy-loaded slot", lazySlotCode);
            return;
          }

          requestBidsForLazySlot(lazySlotCode);
        });
      },
      {
        rootMargin: DISTANCE_IN_PIXELS_FOR_LAZY_LOADING,
      },
    );
    (document.querySelectorAll(".lazyAd").forEach(function (lazyElement) {
      // 13102026: first-screen slots that also carry "lazyAd" are not observed.
      if (!isLazyLoadedSlotCode(lazyElement.id)) {
        adsDebugLog("lazyAd element not observed, not a lazy-loaded slot", lazyElement.id);
        return;
      }

      i.observe(lazyElement);
    }),
      googletag
        .pubads()
        .getSlots()
        .forEach(function (i) {
          var a = i.getSlotElementId();
          let r = i.getTargeting("refresh_count"),
            s;
          var d = new IntersectionObserver(
            function (e) {
              e.forEach((e) => {
                var d = e.target.id;
                e.isIntersecting
                  ? (s = setInterval(function () {
                      let advertiserId, orderId;
                      try {
                        var responseInformation = i.getResponseInformation();
                        advertiserId =
                          responseInformation &&
                          responseInformation.advertiserId;
                        orderId =
                          responseInformation && responseInformation.campaignId;
                      } catch (error) {}

                      if (
                        GAM_NOREFRESH_ADVERTISER_IDS.includes(advertiserId) ||
                        GAM_NOREFRESH_ORDER_IDS.includes(orderId) ||
                        GAM_NOREFRESH_ADUNITS.includes(a) ||
                        "visible" !== document.visibilityState
                      ) {
                        adsDebugLog("refresh skipped", {
                          slot: a,
                          advertiserId: advertiserId,
                          orderId: orderId,
                          visibilityState: document.visibilityState,
                        });
                        return;
                      }

                      adsDebugLog("refresh tick", {
                        slot: a,
                        intervalSeconds: getRefreshIntervalSeconds(a),
                        refreshCount: r,
                      });

                      var nextRefreshCount = (parseInt(r, 10) || 0) + 1;
                      i.setTargeting("refresh_count", String(nextRefreshCount));
                      i.setTargeting(
                        "refresh_bucket",
                        getRefreshBucket(nextRefreshCount),
                      );

                      if (
                        !window.pbjs ||
                        typeof pbjs.requestBids !== "function"
                      ) {
                        googletag.pubads().refresh([i]);
                        r = nextRefreshCount;
                        return;
                      }

                      pbjs.requestBids({
                        timeout: PREBID_TIMEOUT,
                        labels: getCurrentPrebidLabels(),
                        adUnitCodes: [d],
                        bidsBackHandler: function () {
                          safeSetPrebidTargeting([d]);
                          googletag.pubads().refresh([i]);
                          r = nextRefreshCount;
                        },
                      });
                    }, 1e3 * getRefreshIntervalSeconds(a)))
                  : clearInterval(s);
              });
            },
            {
              threshold: VISIBILITY_PERCENT_FOR_REFRESH,
            },
          );
          document.querySelectorAll("#" + a).forEach((e) => {
            d.observe(e);
          });
        }));
  });
}
